webpackJsonp([1],{

/***/ "+9YK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_player_vue__ = __webpack_require__("lGuZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6e04a30f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_player_vue__ = __webpack_require__("OWl9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6e04a30f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_player_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+iuj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Label_vue__ = __webpack_require__("4/IN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc0d8c0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Label_vue__ = __webpack_require__("f825");
function injectStyle (ssrContext) {
  __webpack_require__("pywU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc0d8c0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Label_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc0d8c0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Label_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+jYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"section md-dark"},[_c('div',{staticClass:"section-content"},[_c('div',{staticClass:"tagline"},[_vm._v(_vm._s(_vm.tagline))]),_c('div',{staticClass:"short-description"},[_vm._v(_vm._s(_vm.shortDescription))]),_c('div',[_c('md-button',{staticClass:"call-to-action md-primary md-raised",on:{"click":_vm.getStarted}},[_vm._v("Get started")])],1)])]),_c('div',{staticClass:"section md-white"},[_c('div',{staticClass:"section-content"},[_c('div',{staticClass:"header"},[_vm._v("How does it work?")]),_vm._l((_vm.steps),function(step,index){return _c('div',{staticClass:"step"},[(index < _vm.steps.length - 1)?_c('div',{staticClass:"step-circle md-white md-elevation-5"},[_c('div',{staticClass:"step-number"},[_vm._v(_vm._s(index + 1))])]):_c('div',{staticClass:"step-circle md-primary md-elevation-5"},[_vm._m(0,true)]),_c('div',{staticClass:"step-text"},[_vm._v(_vm._s(step))])])})],2)]),_c('div',{staticClass:"section md-dark"},[_c('div',{staticClass:"section-content"},[_c('div',{staticClass:"header"},[_vm._v("Why does this exist?")]),_vm._l((_vm.description),function(sentence){return _c('div',{staticClass:"template"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(sentence))])])})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-number"},[_c('i',{staticClass:"material-icons"},[_vm._v("done")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+qWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cropperjs__ = __webpack_require__("sRoY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cropperjs__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-agency-dialog',

  components: {
    VueCropper: __WEBPACK_IMPORTED_MODULE_4_vue_cropperjs___default.a
  },

  data: function data() {
    return {
      form: {
        name: null,
        description: null,
        website: null
      },
      image: null,
      cropperContainerStyle: {
        width: '400px',
        height: '400px'
      },
      showSnackbar: false
    };
  },


  validations: {
    form: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(3)
      },
      description: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(800)
      },
      website: {
        url: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["url"]
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    newAgencyId: function newAgencyId(state) {
      return state.agency.newAgencyId;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["c" /* mapBoolean */])({
    namespace: 'ui',
    key: 'isNewAgencyDialogOpen',
    setTrue: 'openNewAgencyDialog',
    setFalse: 'closeNewAgencyDialog'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getLinkToAgency: 'agency/getLinkToAgency'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    saveNewAgency: 'agency/saveNewAgency'
  }), {
    handleImageChange: function handleImageChange(event) {
      var _this = this;

      // get image data URL
      var file = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        // save image data URL
        var dataURL = reader.result;
        _this.image = dataURL;
        // update cropper if already initialised
        if (_this.$refs.cropper) _this.$refs.cropper.replace(dataURL);
      };
    },
    cropImage: function cropImage() {
      var cropper = this.$refs.cropper;

      if (cropper) {
        var canvas = cropper.getCroppedCanvas({
          width: 150,
          height: 150
        });
        return canvas.toDataURL();
      }
    },
    getValidationClass: function getValidationClass(fieldName) {
      var field = this.$v.form[fieldName];
      if (field) {
        return {
          'md-invalid': field.$error
        };
      }
    },
    clearForm: function clearForm() {
      this.$v.$reset();
      this.form.name = null;
      this.form.description = null;
      this.form.website = null;
      this.image = null;
    },
    submitForm: function submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveNewAgency({
          agency: this.form,
          logo: this.cropImage()
        });
        this.isNewAgencyDialogOpen = false;
        this.showSnackbar = true;
      }
    }
  })
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "13ja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-list-container"},[(!_vm.doVideosExist && _vm.areVideosLoaded)?_c('md-empty-state',{attrs:{"md-icon":"video_library","md-label":"We're out of videos!","md-description":"You can submit a video now, or check here later."}},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.openNewVideoDialog}},[_vm._v("Submit video")])],1):_vm._e(),(_vm.doVideosExist)?_c('div',{staticClass:"video-list"},_vm._l((_vm.videos),function(video){return _c('video-card',{key:video['.key'],attrs:{"video":video,"event":_vm.showEvents && _vm.getEventById(video.event)}})})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1OUD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1mS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agency-list-container"},[(!_vm.doAgenciesExist && _vm.areAgenciesLoaded)?_c('md-empty-state',{attrs:{"md-icon":"people","md-label":"No agencies","md-description":"There are no agencies in the system yet."}},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.openNewAgencyDialog}},[_vm._v("Create new agency")])],1):_vm._e(),(_vm.doAgenciesExist)?_c('div',{staticClass:"agency-list"},_vm._l((_vm.agencies),function(agency){return _c('agency-card',{key:agency['.key'],attrs:{"agency":agency}})})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "24IH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validators__ = __webpack_require__("C+7C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_api__ = __webpack_require__("ZXJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Message__ = __webpack_require__("yJ2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TweetPreview__ = __webpack_require__("texN");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-video-dialog',

  data: function data() {
    return {
      form: {
        url: null,
        event: null
      },
      tweetLoading: false,
      showSnackbar: false
    };
  },


  components: {
    message: __WEBPACK_IMPORTED_MODULE_8__components_Message__["a" /* default */],
    TweetPreview: __WEBPACK_IMPORTED_MODULE_9__components_TweetPreview__["a" /* default */]
  },

  validations: {
    form: {
      url: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"],
        url: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["url"],
        tweetUrl: __WEBPACK_IMPORTED_MODULE_5__validators__["a" /* tweetUrl */]
      },
      event: {
        required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
      }
    },
    tweet: {
      required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])({
    newVideoId: function newVideoId(state) {
      return state.video.newVideoId;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    eventIdsByName: 'event/eventIdsByName'
  }), Object(__WEBPACK_IMPORTED_MODULE_6__utilities__["c" /* mapBoolean */])({
    namespace: 'ui',
    key: 'isNewVideoDialogOpen',
    setTrue: 'openNewVideoDialog',
    setFalse: 'closeNewVideoDialog'
  })),

  asyncComputed: {
    tweet: function tweet() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.$v.form.url.$invalid) {
                  _context.next = 19;
                  break;
                }

                _this.tweet = null;
                params = { tweetUrl: _this.form.url };

                _this.tweetLoading = true;
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_7__utilities_api__["a" /* serverless */].get('/tweetInfo', { params: params });

              case 7:
                response = _context.sent;

                console.log(response.data);
                _this.tweetLoading = false;
                return _context.abrupt('return', response.data);

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](4);

                _this.tweetLoading = false;
                return _context.abrupt('return', null);

              case 17:
                _context.next = 21;
                break;

              case 19:
                _this.tweetLoading = false;
                return _context.abrupt('return', null);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 13]]);
      }))();
    }
  },

  watch: {
    isNewVideoDialogOpen: function isNewVideoDialogOpen(newVal) {
      // when new video dialog opens...
      if (newVal) {
        // if on event page...
        if (this.$route.params.eventId) {
          // pre-fill form with event
          var eventId = this.$route.params.eventId;

          this.form.event = eventId;
        }
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6__utilities__["d" /* mapGettersWithParams */])({
    getLinkToVideo: 'video/getLinkToVideo'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    saveNewVideo: 'video/saveNewVideo',
    loadEvents: 'event/loadEvents'
  }), {
    getValidationClass: function getValidationClass(fieldName) {
      var field = this.$v.form[fieldName];
      if (field) {
        if (fieldName === 'url') {
          return {
            'md-invalid': field.$error || this.$v.tweet.$error
          };
        } else {
          return {
            'md-invalid': field.$error
          };
        }
      }
    },
    clearForm: function clearForm() {
      this.$v.$reset();
      this.form.url = null;
      this.form.event = null;
      this.tweet = null;
    },
    submitForm: function submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveNewVideo({
          video: {
            url: this.tweet.url,
            width: this.tweet.width,
            height: this.tweet.height,
            thumbnail: this.tweet.thumbnail,
            title: this.tweet.title,
            event: this.form.event
          }
        });
        this.isNewVideoDialogOpen = false;
        this.showSnackbar = true;
      }
    }
  })
});

/***/ }),

/***/ "3ws+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{staticClass:"event-header md-elevation-10"},[(_vm.image)?_c('img',{staticClass:"image",attrs:{"src":_vm.image}}):_vm._e(),_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.event.name))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.event.description))]),_c('div',{staticClass:"agencies"},[_c('div',[_vm._v("Relief managed by:")]),_vm._l((_vm.agencies),function(agency,index){return _c('span',{staticClass:"agency"},[_c('router-link',{staticClass:"agency-link",attrs:{"to":_vm.getLinkToAgency(agency)}},[_vm._v(_vm._s(agency.name))]),(index < _vm.agencies.length - 1)?_c('span',[_vm._v("  •  ")]):_vm._e()],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4/IN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kl-label',

  props: ['text']
});

/***/ }),

/***/ "4f4P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EventCard__ = __webpack_require__("z6Yr");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-list',

  components: {
    EventCard: __WEBPACK_IMPORTED_MODULE_3__components_EventCard__["a" /* default */]
  },

  props: ['events'],

  created: function created() {
    this.loadTags(); // required for showing tag counts
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    areEventsLoaded: function areEventsLoaded(state) {
      return state.event.areEventsLoaded;
    }
  }), {
    doEventsExist: function doEventsExist() {
      return this.events && this.events.length > 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getImage: 'event/getImage'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    openNewEventDialog: 'ui/openNewEventDialog'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    loadTags: 'tag/loadTags'
  }))
});

/***/ }),

/***/ "4x6I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbar',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    isSignedIn: 'auth/isSignedIn'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    openDrawer: 'ui/openDrawer'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    signInWithGoogle: 'auth/signInWithGoogle'
  }))
});

/***/ }),

/***/ "5Qkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5wBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__("yp89");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-info',

  props: ['video', 'event'],

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["d" /* mapGettersWithParams */])({
    getLinkToEvent: 'event/getLinkToEvent'
  }))
});

/***/ }),

/***/ "6EKJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6eDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tweet-preview',

  props: ['tweet', 'loading']
});

/***/ }),

/***/ "6lOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventHeader_vue__ = __webpack_require__("EyTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9c398c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EventHeader_vue__ = __webpack_require__("3ws+");
function injectStyle (ssrContext) {
  __webpack_require__("yjWt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b9c398c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9c398c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EventHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6nDn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "81+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase__ = __webpack_require__("8m66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuexfire__ = __webpack_require__("reQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuexfire__);









var agenciesRef = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('agencies');
var usersRef = __WEBPACK_IMPORTED_MODULE_6__firebase__["b" /* db */].ref('users');

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    agencies: [],
    areAgenciesLoaded: false,
    areAgenciesLoading: false,
    uploading: false,
    newAgencyId: null // used for snackbar
  },

  getters: {
    doAgenciesExist: function doAgenciesExist(state) {
      return state.agencies.length > 0;
    },

    currentUsersAgencies: function currentUsersAgencies(state, getters, rootState, rootGetters) {
      var currentUid = rootGetters['auth/currentUid'];
      return state.agencies.filter(function (agency) {
        return agency.admins[currentUid];
      });
    },

    agencyIdsByName: function agencyIdsByName(state) {
      var agencyIdsByName = {};
      state.agencies.forEach(function (agency) {
        agencyIdsByName[agency.name] = agency['.key'];
      });
      return agencyIdsByName;
    },

    getAgencyById: function getAgencyById(state) {
      return function (agencyId) {
        return state.agencies.find(function (agency) {
          return agency['.key'] === agencyId;
        });
      };
    },

    getAgenciesByIds: function getAgenciesByIds(state, getters) {
      return function (agencyIds) {
        var agencies = agencyIds.map(function (agencyId) {
          return getters.getAgencyById(agencyId);
        });
        return agencies === {} ? null : agencies;
      };
    },

    getAgencyAdmins: function getAgencyAdmins() {
      return function (agency) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(agency.admins);
      };
    },

    getLinkToAgency: function getLinkToAgency() {
      return function (agency) {
        if (typeof agency === 'string') {
          return '/agency/' + agency;
        } else {
          return '/agency/' + agency['.key'];
        }
      };
    },

    isCurrentUserAnAgencyAdmin: function isCurrentUserAnAgencyAdmin(state, getters, rootState, rootGetters) {
      return function (agency) {
        var currentUid = rootGetters['auth/currentUid'];
        var agencyAdmins = getters.getAgencyAdmins(agency);
        return agencyAdmins.includes(currentUid);
      };
    }
  },

  mutations: {
    setAreAgenciesLoading: function setAreAgenciesLoading(state) {
      state.areAgenciesLoading = true;
    },
    setAreAgenciesLoaded: function setAreAgenciesLoaded(state) {
      state.areAgenciesLoading = false;
      state.areAgenciesLoaded = true;
    },

    setUploading: function setUploading(state, uploading) {
      state.uploading = uploading;
    },
    setNewAgencyId: function setNewAgencyId(state, value) {
      state.newAgencyId = value;
    }
  },

  actions: {
    setAgenciesRef: Object(__WEBPACK_IMPORTED_MODULE_7_vuexfire__["firebaseAction"])(function (_ref, _ref2) {
      var bindFirebaseRef = _ref.bindFirebaseRef;
      var ref = _ref2.ref,
          commit = _ref2.commit;

      bindFirebaseRef('agencies', ref, {
        readyCallback: function readyCallback() {
          commit('setAreAgenciesLoaded');
        }
      });
    }),

    loadAgencies: function loadAgencies(_ref3) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;

      if (!state.areAgenciesLoaded && !state.areAgenciesLoading) {
        commit('setAreAgenciesLoading');
        dispatch('setAgenciesRef', { ref: agenciesRef, commit: commit });
      }
    },
    uploadLogo: function uploadLogo(context, _ref4) {
      var dataURL = _ref4.dataURL,
          newAgencyId = _ref4.newAgencyId;

      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var path = 'agency/' + newAgencyId + '.jpg';
        var uploadTask = __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* storage */].ref(path).putString(dataURL, 'data_url');
        uploadTask.on('state_changed', {
          error: function error(_error) {
            return reject(_error);
          },
          complete: function complete() {
            return resolve(uploadTask.snapshot.downloadURL);
          }
        });
      });
    },
    saveNewAgency: function saveNewAgency(_ref5, _ref6) {
      var _this = this;

      var rootState = _ref5.rootState,
          commit = _ref5.commit,
          dispatch = _ref5.dispatch;
      var agency = _ref6.agency,
          logo = _ref6.logo;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var agencyObject, newAgencyRef, newAgencyId, logoURL, uid;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                agencyObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, agency);

                // get new agency ID

                newAgencyRef = agenciesRef.push();
                newAgencyId = newAgencyRef.key;

                commit('setNewAgencyId', newAgencyId);

                // upload logo
                logoURL = void 0;

                if (!logo) {
                  _context.next = 11;
                  break;
                }

                commit('setUploading', true);
                _context.next = 9;
                return dispatch('uploadLogo', {
                  dataURL: logo,
                  newAgencyId: newAgencyId
                });

              case 9:
                logoURL = _context.sent;

                commit('setUploading', false);

              case 11:

                // save agency
                uid = rootState.auth.user.uid;

                agencyObject.admins = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, uid, true);
                if (logoURL) agencyObject.logo = logoURL;
                newAgencyRef.set(agencyObject);

                // save user
                usersRef.child(uid).child('adminOf').update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, newAgencyId, true));

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "8m66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
  apiKey: 'AIzaSyBxeua6P2GlAONRY2rGAqQK8zWbDuE-Pl8',
  authDomain: 'disaster-damage-video-tagger.firebaseapp.com',
  databaseURL: 'https://disaster-damage-video-tagger.firebaseio.com',
  projectId: 'disaster-damage-video-tagger',
  storageBucket: 'disaster-damage-video-tagger.appspot.com',
  messagingSenderId: '737684330599'

  /* eslint-disable no-unused-vars */
};var app = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database();
var auth = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth();
var storage = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage();

/***/ }),

/***/ "8s9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"md-active":_vm.isNewEventDialogOpen,"md-close-on-esc":false,"md-click-outside-to-close":false},on:{"update:mdActive":function($event){_vm.isNewEventDialogOpen=$event},"md-closed":_vm.clearForm}},[_c('md-dialog-title',[_vm._v("Create new event")]),_c('md-dialog-content',[_c('md-field',{class:_vm.getValidationClass('name')},[_c('label',{attrs:{"for":"event-name"}},[_vm._v("Event name")]),_c('md-input',{attrs:{"name":"event-name"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),(!_vm.$v.form.name.required)?_c('span',{staticClass:"md-error"},[_vm._v("An event must have a name.")]):(!_vm.$v.form.name.minLength)?_c('span',{staticClass:"md-error"},[_vm._v("Must be at least 3 letters long.")]):_vm._e()],1),_c('md-field',{class:_vm.getValidationClass('description')},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description")]),_c('md-textarea',{attrs:{"name":"description","md-counter":"800"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),(!_vm.$v.form.description.required)?_c('span',{staticClass:"md-error"},[_vm._v("An event must have a description.")]):(!_vm.$v.form.description.maxLength)?_c('span',{staticClass:"md-error"},[_vm._v("Cannot be longer than 800 characters.")]):_vm._e()],1),_c('md-field',{class:_vm.getValidationClass('agencies')},[_c('label',{attrs:{"for":"agencies"}},[_vm._v("Assigned agencies")]),_c('md-select',{attrs:{"name":"agencies","multiple":"multiple","md-dense":"md-dense"},model:{value:(_vm.form.agencies),callback:function ($$v) {_vm.$set(_vm.form, "agencies", $$v)},expression:"form.agencies"}},_vm._l((_vm.agencyIdsByName),function(id,name){return _c('md-option',{key:id,attrs:{"value":id}},[_vm._v(_vm._s(name))])})),(!_vm.$v.form.agencies.required)?_c('span',{staticClass:"md-error"},[_vm._v("An event must be assigned to at least one agency.")]):_vm._e()],1)],1),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-secondary",on:{"click":function($event){_vm.isNewEventDialogOpen = false}}},[_vm._v("Cancel")]),_c('md-button',{staticClass:"md-primary",on:{"click":_vm.submitForm}},[_vm._v("Create")])],1)],1),_c('md-snackbar',{attrs:{"md-active":_vm.showSnackbar,"md-duration":5000},on:{"update:mdActive":function($event){_vm.showSnackbar=$event}}},[_c('span',[_vm._v("Event has been successfully created.")]),(_vm.newEventId)?_c('router-link',{attrs:{"to":_vm.getLinkToEvent(_vm.newEventId)}},[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.showSnackbar = false}}},[_vm._v("Go to event")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AOoT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AQA2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ah09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTagDialog_vue__ = __webpack_require__("T0oi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad04db66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewTagDialog_vue__ = __webpack_require__("U7GS");
function injectStyle (ssrContext) {
  __webpack_require__("Km6o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad04db66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewTagDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad04db66_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewTagDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BAph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagForm_vue__ = __webpack_require__("xC7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a313b7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TagForm_vue__ = __webpack_require__("z6Mc");
function injectStyle (ssrContext) {
  __webpack_require__("zTpQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a313b7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a313b7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TagForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C+7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tweetUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_api__ = __webpack_require__("ZXJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");




// export const youTubeUrl = withParams(
//   {type: 'youTubeUrl'},
//   (url) => {
//     return isYouTubeUrl(url)
//   }
// )

// export const youTubeVideo = withParams(
//   {type: 'youTubeVideo'},
//   async (url) => {
//     // extract YouTube video ID from URL
//     const videoId = extractYouTubeVideoId(url)
//
//     // check if video exists
//     if (!videoId) return false
//     const params = {
//       id: videoId,
//       part: 'id',
//     }
//     const {data} = await youTube.get('/videos', {params})
//     return data.items.length > 0
//   },
// )

var tweetUrl = Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib__["withParams"])({ type: 'tweetUrl' }, function (url) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["b" /* isTweetUrl */])(url);
});

/***/ }),

/***/ "C0Vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'agency-header',

  props: ['agency']
});

/***/ }),

/***/ "CDSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AgencyHeader__ = __webpack_require__("STgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_EventList__ = __webpack_require__("IVbU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AddSpeedDial__ = __webpack_require__("xrI/");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Agency',

  components: {
    AgencyHeader: __WEBPACK_IMPORTED_MODULE_4__components_AgencyHeader__["a" /* default */],
    EventList: __WEBPACK_IMPORTED_MODULE_5__components_EventList__["a" /* default */],
    AddSpeedDial: __WEBPACK_IMPORTED_MODULE_6__components_AddSpeedDial__["a" /* default */]
  },

  created: function created() {
    this.loadAgencies();
    this.loadEvents();
    this.loadVideos(); // for event card backgrounds
  },
  data: function data() {
    return {
      activeTab: 'events'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapState */])({
    areAgenciesLoaded: function areAgenciesLoaded(state) {
      return state.agency.areAgenciesLoaded;
    },
    areEventsLoaded: function areEventsLoaded(state) {
      return state.event.areEventsLoaded;
    }
  }), {
    agency: function agency() {
      if (this.areAgenciesLoaded && this.$route.params.agencyId) {
        return this.getAgencyById(this.$route.params.agencyId);
      }
    },
    events: function events() {
      if (this.areEventsLoaded && this.agency && this.agency.events) {
        return this.getEventsByIds(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.agency.events));
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    loadAgencies: 'agency/loadAgencies',
    loadEvents: 'event/loadEvents',
    loadVideos: 'video/loadVideos'
  }), Object(__WEBPACK_IMPORTED_MODULE_3__utilities__["d" /* mapGettersWithParams */])({
    getAgencyById: 'agency/getAgencyById',
    getEventsByIds: 'event/getEventsByIds'
  }), {
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab;
    }
  })
});

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__("8m66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuexfire__ = __webpack_require__("reQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");









var usersRef = __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* db */].ref('users');

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    user: null,
    data: null,
    isUserLoading: false,
    isUserLoaded: false
  },

  getters: {
    isSignedIn: function isSignedIn(state) {
      return state.user !== null && state.data !== null;
    },

    isSiteAdmin: function isSiteAdmin(state, getters) {
      return getters.isSignedIn && state.data.type === 'site admin';
    },

    currentUid: function currentUid(state) {
      return state.user && state.user.uid;
    }
  },

  mutations: {
    updateUser: function updateUser(state, _ref) {
      var user = _ref.user;

      state.user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.user, {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL
      });
    },
    clearUser: function clearUser(state) {
      state.user = null;
      state.data = null;
    },
    setIsUserLoaded: function setIsUserLoaded(state) {
      state.isUserLoading = false;
      state.isUserLoaded = true;
    },
    setIsUserLoading: function setIsUserLoading(state) {
      state.isUserLoading = true;
    }
  },

  actions: {
    setDataRef: Object(__WEBPACK_IMPORTED_MODULE_6_vuexfire__["firebaseAction"])(function (_ref2, _ref3) {
      var bindFirebaseRef = _ref2.bindFirebaseRef;
      var ref = _ref3.ref,
          commit = _ref3.commit;

      bindFirebaseRef('data', ref, {
        readyCallback: function readyCallback() {
          commit('setIsUserLoaded');
        }
      });
    }),

    signInWithGoogle: function signInWithGoogle(_ref4) {
      var _this = this;

      var dispatch = _ref4.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var provider, result, token, user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                provider = new __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth.GoogleAuthProvider();
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* auth */].signInWithPopup(provider);

              case 3:
                result = _context.sent;
                token = result.credential.accessToken;
                user = result.user;

                dispatch('saveUser', { user: user, token: token });
                __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({ name: 'browse' });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveUser: function saveUser(context, _ref5) {
      var user = _ref5.user,
          token = _ref5.token;

      // Check if user already exists.
      var userExists = void 0;
      usersRef.once('value', function (snapshot) {
        userExists = snapshot.hasChild(user.uid);
      });
      if (!userExists) {
        usersRef.child(user.uid).set({
          type: 'volunteer',
          token: token,
          createdAt: __WEBPACK_IMPORTED_MODULE_5_moment___default()().toISOString()
        });
      }
    },
    getUser: function getUser(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('setIsUserLoading');
      __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* auth */].onAuthStateChanged(function (user) {
        if (user) {
          commit('updateUser', { user: user });
          dispatch('setDataRef', {
            ref: usersRef.child(user.uid),
            commit: commit
          });
        } else {
          commit('clearUser');
          commit('setIsUserLoaded');
        }
      });
    },
    signOut: function signOut(_ref7) {
      var _this2 = this;

      var commit = _ref7.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__firebase__["a" /* auth */].signOut();

              case 2:
                commit('clearUser');
                __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({ name: 'home' });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "DroQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EL+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Label__ = __webpack_require__("+iuj");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drawer',

  components: {
    'kl-label': __WEBPACK_IMPORTED_MODULE_3__components_Label__["a" /* default */]
  },

  created: function created() {
    this.loadAgencies();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    user: function user(state) {
      return state.auth.user;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    isSignedIn: 'auth/isSignedIn',
    currentUsersAgencies: 'agency/currentUsersAgencies'
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["c" /* mapBoolean */])({
    namespace: 'ui',
    key: 'isDrawerOpen',
    setTrue: 'openDrawer',
    setFalse: 'closeDrawer'
  }), {
    isUserInAnyAgency: function isUserInAnyAgency() {
      return this.currentUsersAgencies.length > 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    signOut: 'auth/signOut',
    signInWithGoogle: 'auth/signInWithGoogle',
    loadAgencies: 'agency/loadAgencies'
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getLinkToAgency: 'agency/getLinkToAgency',
    isCurrentUserAnAgencyAdmin: 'agency/isCurrentUserAnAgencyAdmin'
  }), {
    click: function click(then) {
      this.isDrawerOpen = false;
      if (then) then();
    }
  })
});

/***/ }),

/***/ "EyTc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__("yp89");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-header',

  props: ['event', 'agencies', 'image'],

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["d" /* mapGettersWithParams */])({
    getLinkToAgency: 'agency/getLinkToAgency'
  }))
});

/***/ }),

/***/ "HNQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("dPB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11adbcc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("+jYT");
function injectStyle (ssrContext) {
  __webpack_require__("DroQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11adbcc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11adbcc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I7c+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video && _vm.event)?_c('md-content',{staticClass:"video-info md-elevation-5"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.video.title))]),_c('div',{staticClass:"event"},[_vm._v("in "),_c('router-link',{staticClass:"event-link",attrs:{"to":_vm.getLinkToEvent(_vm.event)}},[_vm._v(_vm._s(_vm.event.name))])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IVbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventList_vue__ = __webpack_require__("4f4P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7ffb646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EventList_vue__ = __webpack_require__("j1yL");
function injectStyle (ssrContext) {
  __webpack_require__("RJbG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7ffb646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7ffb646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EventList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_ui__ = __webpack_require__("XZap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_agency__ = __webpack_require__("81+P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_event__ = __webpack_require__("ePeP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_video__ = __webpack_require__("qLZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_tag__ = __webpack_require__("OYHR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuexfire__ = __webpack_require__("reQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuexfire__);











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: true,
  modules: {
    ui: __WEBPACK_IMPORTED_MODULE_3__store_modules_ui__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_4__store_modules_auth__["a" /* default */],
    agency: __WEBPACK_IMPORTED_MODULE_5__store_modules_agency__["a" /* default */],
    event: __WEBPACK_IMPORTED_MODULE_6__store_modules_event__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_7__store_modules_video__["a" /* default */],
    tag: __WEBPACK_IMPORTED_MODULE_8__store_modules_tag__["a" /* default */]
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9_vuexfire__["firebaseMutations"])
}));

/***/ }),

/***/ "JFTN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{staticClass:"agency-header md-elevation-10"},[_c('img',{staticClass:"image md-elevation-10",attrs:{"src":_vm.agency.logo}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.agency.name))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.agency.description))]),(_vm.agency.website)?_c('a',{staticClass:"website",attrs:{"href":_vm.agency.website}},[_vm._v(_vm._s(_vm.agency.website))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JnBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagList_vue__ = __webpack_require__("ucc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e0891d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TagList_vue__ = __webpack_require__("ZcaK");
function injectStyle (ssrContext) {
  __webpack_require__("r6jk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26e0891d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e0891d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TagList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KMRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"browse"},[_c('md-tabs',{staticClass:"md-primary",attrs:{"md-sync-route":"md-sync-route","md-alignment":"centered"},on:{"md-changed":_vm.handleTabChange}},[_c('md-tab',{attrs:{"md-label":"Videos","to":"/browse/videos","id":"videos"}}),_c('md-tab',{attrs:{"md-label":"Events","to":"/browse/events","id":"events"}}),_c('md-tab',{attrs:{"md-label":"Agencies","to":"/browse/agencies","id":"agencies"}})],1),(_vm.activeTab === 'videos')?_c('video-list',{attrs:{"videos":_vm.videos,"showEvents":true}}):_vm._e(),(_vm.activeTab === 'events')?_c('event-list',{attrs:{"events":_vm.events}}):_vm._e(),(_vm.activeTab === 'agencies')?_c('agency-list',{attrs:{"agencies":_vm.agencies}}):_vm._e(),_c('router-view'),_c('add-speed-dial')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Km6o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LPMx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edd17da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kTCo");
function injectStyle (ssrContext) {
  __webpack_require__("ydlG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edd17da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MGIb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MH9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video)?_c('video-player',{ref:"videoPlayer",attrs:{"options":_vm.playerOptions},on:{"ready":_vm.playerReady,"loadeddata":_vm.playerLoadedData,"timeupdate":_vm.playerTimeUpdated}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mtwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-card-container"},[_c('router-link',{attrs:{"to":_vm.getLinkToVideo(_vm.video)}},[_c('div',{staticClass:"video-card md-elevation-5"},[_c('img',{attrs:{"src":_vm.video.thumbnail}}),_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"black-filler md-elevation-5"}),_c('md-icon',{staticClass:"md-size-2x"},[_vm._v("play_circle_filled")]),_c('kl-label',{staticClass:"label",attrs:{"text":_vm.tagCount}})],1)]),_c('router-link',{staticClass:"title",attrs:{"to":_vm.getLinkToVideo(_vm.video)}},[_vm._v(_vm._s(_vm.video.title))]),(_vm.event)?_c('div',{staticClass:"event"},[_vm._v("in "),_c('router-link',{staticClass:"event-link",attrs:{"to":_vm.getLinkToEvent(_vm.event)}},[_vm._v(_vm._s(_vm.event.name))])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N4JW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agency_vue__ = __webpack_require__("CDSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0495f0ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Agency_vue__ = __webpack_require__("hKkw");
function injectStyle (ssrContext) {
  __webpack_require__("AQA2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0495f0ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0495f0ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Agency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_video_player__ = __webpack_require__("NBiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_async_computed__ = __webpack_require__("PlbA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_async_computed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_async_computed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_touch__ = __webpack_require__("I0MY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_touch__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_video_player___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_async_computed___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_touch___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OWl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('video',{staticClass:"video-js"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OYHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toArray__ = __webpack_require__("7nRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase__ = __webpack_require__("8m66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuexfire__ = __webpack_require__("reQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);











var tagsRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('tags');
var videosRef = __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* db */].ref('videos');

var stages = ['play', 'crop', 'range-start', 'range-end', 'dialog', 'done'];

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    // tagger
    crop: null,
    range: {
      start: null,
      end: null
    },
    stage: 0,
    lastStageIndex: stages.length - 1,
    uploading: false,

    // tags
    tags: [],
    areTagsLoaded: false,
    areTagsLoading: false
  },
  getters: {
    doTagsExist: function doTagsExist(state) {
      return state.tags.length > 0;
    },
    getStageName: function getStageName() {
      return function (stage) {
        return stages[stage];
      };
    },
    currentStageName: function currentStageName(state, getters) {
      return getters.getStageName(state.stage);
    },
    getTagById: function getTagById(state) {
      return function (tagId) {
        return state.tags.find(function (tag) {
          return tag['.key'] === tagId;
        });
      };
    },
    getTagsByVideoIds: function getTagsByVideoIds(state, getters) {
      return function (videoIds) {
        var unjoined = videoIds.map(function (videoId) {
          return getters.getTagsByVideoId(videoId);
        });

        var _unjoined = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toArray___default()(unjoined),
            first = _unjoined[0],
            rest = _unjoined.slice(1);

        return first.concat.apply(first, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(rest));
      };
    },
    getTagsByVideoId: function getTagsByVideoId(state) {
      return function (videoId) {
        return state.tags.filter(function (tag) {
          return tag.video === videoId;
        });
      };
    }
  },
  mutations: {
    // tagger
    setCrop: function setCrop(state, crop) {
      state.crop = crop;
    },
    clearCrop: function clearCrop(state) {
      state.crop = null;
    },
    setRangeStart: function setRangeStart(state, rangeStart) {
      state.range.start = rangeStart;
    },
    setRangeEnd: function setRangeEnd(state, rangeEnd) {
      state.range.end = rangeEnd;
    },
    clearRangeStart: function clearRangeStart(state) {
      state.range.start = null;
    },
    clearRangeEnd: function clearRangeEnd(state) {
      state.range.end = null;
    },
    resetTagger: function resetTagger(state) {
      state.crop = null;
      state.range.start = null;
      state.range.end = null;
      state.stage = 0;
    },

    // stages
    nextStage: function nextStage(state) {
      state.stage = (state.stage + 1) % stages.length;
    },
    previousStage: function previousStage(state) {
      state.stage = state.stage === 0 ? state.stage : state.stage - 1;
    },

    // images
    setUploading: function setUploading(state, uploading) {
      state.uploading = uploading;
    },

    // tags
    setAreTagsLoaded: function setAreTagsLoaded(state) {
      state.areTagsLoading = false;
      state.areTagsLoaded = true;
    },
    setAreTagsLoading: function setAreTagsLoading(state) {
      state.areTagsLoading = true;
    }
  },
  actions: {
    uploadImages: function uploadImages(_ref, newTagId) {
      var state = _ref.state,
          commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(state.crop.images).map(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            imageType = _ref3[0],
            dataURL = _ref3[1];

        return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var path = 'tags/' + imageType + '/' + newTagId + '.jpg';
          var uploadTask = __WEBPACK_IMPORTED_MODULE_7__firebase__["c" /* storage */].ref(path).putString(dataURL, 'data_url');
          uploadTask.on('state_changed', {
            error: function error(_error) {
              reject(_error);
            },
            complete: function complete() {
              resolve([imageType, uploadTask.snapshot.downloadURL]);
            }
          });
        });
      }));
    },
    saveNewTag: function saveNewTag(_ref4, _ref5) {
      var _this = this;

      var state = _ref4.state,
          commit = _ref4.commit,
          dispatch = _ref4.dispatch,
          rootGetters = _ref4.rootGetters;
      var details = _ref5.details,
          videoId = _ref5.videoId;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var newTagRef, newTagId, imageURLs, number, videoTagsIndex;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // get new tag ID
                newTagRef = tagsRef.push();
                newTagId = newTagRef.key;

                // upload images

                commit('setUploading', true);
                _context.t0 = __WEBPACK_IMPORTED_MODULE_9_lodash__["fromPairs"];
                _context.next = 6;
                return dispatch('uploadImages', newTagId);

              case 6:
                _context.t1 = _context.sent;
                imageURLs = (0, _context.t0)(_context.t1);

                commit('setUploading', false);

                // get tag number
                number = rootGetters['video/countTagsInVideo'](videoId) + 1;


                newTagRef.set({
                  number: number,
                  video: videoId,
                  crop: {
                    position: state.crop.position,
                    time: state.crop.time,
                    images: imageURLs
                  },
                  range: state.range,
                  details: details
                });

                // add new tag to video's tags index
                videoTagsIndex = videosRef.child(videoId).child('tags');

                videoTagsIndex.child(newTagId).set(number);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    setTagsRef: Object(__WEBPACK_IMPORTED_MODULE_8_vuexfire__["firebaseAction"])(function (_ref6, _ref7) {
      var bindFirebaseRef = _ref6.bindFirebaseRef;
      var ref = _ref7.ref,
          commit = _ref7.commit;

      bindFirebaseRef('tags', ref, {
        readyCallback: function readyCallback() {
          commit('setAreTagsLoaded');
        }
      });
    }),

    loadTags: function loadTags(_ref8) {
      var state = _ref8.state,
          dispatch = _ref8.dispatch,
          commit = _ref8.commit;

      if (!state.areTagsLoaded && !state.areTagsLoading) {
        commit('setAreTagsLoading');
        dispatch('setTagsRef', { ref: tagsRef, commit: commit });
      }
    }
  }
});

/***/ }),

/***/ "P8kE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-speed-dial',{staticClass:"md-bottom-right",attrs:{"md-direction":"top"}},[_c('md-speed-dial-target',{on:{"click":_vm.openNewVideoDialog}},[_c('md-icon',[_vm._v("add")])],1),_c('md-speed-dial-content',[_c('md-button',{staticClass:"md-icon-button md-transparent",on:{"click":_vm.openNewAgencyDialog}},[_c('md-icon',[_vm._v("people")])],1),_c('md-button',{staticClass:"md-icon-button md-transparent",on:{"click":_vm.openNewEventDialog}},[_c('md-icon',[_vm._v("event")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QIXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AgencyCard__ = __webpack_require__("ttC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'agency-list',

  components: {
    AgencyCard: __WEBPACK_IMPORTED_MODULE_1__components_AgencyCard__["a" /* default */]
  },

  props: ['agencies'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapState */])({
    areAgenciesLoaded: function areAgenciesLoaded(state) {
      return state.agency.areAgenciesLoaded;
    }
  }), {
    doAgenciesExist: function doAgenciesExist() {
      return this.agencies && this.agencies.length > 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({
    openNewAgencyDialog: 'ui/openNewAgencyDialog'
  }))
});

/***/ }),

/***/ "RJbG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Raba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_VideoCard__ = __webpack_require__("fbZV");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-list',

  components: {
    VideoCard: __WEBPACK_IMPORTED_MODULE_3__components_VideoCard__["a" /* default */]
  },

  props: ['videos', 'showEvents'],

  created: function created() {
    if (this.showEvents) this.loadEvents();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    areVideosLoaded: function areVideosLoaded(state) {
      return state.video.areVideosLoaded;
    }
  }), {
    doVideosExist: function doVideosExist() {
      return this.videos && this.videos.length > 0;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getEventById: 'event/getEventById'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    openNewVideoDialog: 'ui/openNewVideoDialog'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    loadEvents: 'event/loadEvents'
  }))
});

/***/ }),

/***/ "STgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyHeader_vue__ = __webpack_require__("C0Vj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df319506_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyHeader_vue__ = __webpack_require__("JFTN");
function injectStyle (ssrContext) {
  __webpack_require__("AOoT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df319506"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df319506_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SWv9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SczH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__ = __webpack_require__("EL+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b68763c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__ = __webpack_require__("Z5On");
function injectStyle (ssrContext) {
  __webpack_require__("SWv9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b68763c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b68763c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T0oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_tagValues__ = __webpack_require__("vJBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TagForm__ = __webpack_require__("BAph");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-tag-dialog',

  components: {
    TagForm: __WEBPACK_IMPORTED_MODULE_3__components_TagForm__["a" /* default */]
  },

  data: function data() {
    return {
      form: Object(__WEBPACK_IMPORTED_MODULE_2__values_tagValues__["a" /* tagForm */])({ includeDescription: true })
    };
  },
  validations: function validations() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__values_tagValues__["d" /* tagValidations */])({
      selectedType: this.form.type
    });
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    images: function images(state) {
      return state.tag.crop && state.tag.crop.images;
    },
    uploading: function uploading(state) {
      return state.tag.uploading;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentStageName: 'tag/currentStageName'
  }), {
    isCurrentStageDialog: function isCurrentStageDialog() {
      return this.currentStageName === 'dialog';
    },
    isCurrentStageDone: function isCurrentStageDone() {
      return this.currentStageName === 'done';
    },
    shouldDialogBeOpen: function shouldDialogBeOpen() {
      return this.isCurrentStageDialog || this.isCurrentStageDone;
    },
    getDialogTitle: function getDialogTitle() {
      if (this.isCurrentStageDialog) return 'Create new tag';
      if (this.isCurrentStageDone) return 'Tag created';
    }
  }),

  watch: {
    uploading: function uploading(newUploading, oldUploading) {
      if (oldUploading && !newUploading) {
        this.nextStage();
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    previousStage: 'tag/previousStage',
    nextStage: 'tag/nextStage'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    saveNewTag: 'tag/saveNewTag'
  }), {
    clearForm: function clearForm() {
      this.$v.$reset();
      this.form.type = null;
      this.form.people.amount = null;
      this.form.people.state = null;
      this.form.people.freedom = null;
      this.form.water.form = null;
      this.form.vehicle.state = null;
      this.form.area.form = null;
      this.form.area.shelter = null;
      this.form.area.service = null;
      this.form.damage.form = null;
      this.form.description = null;
    },
    submitForm: function submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var _form = this.form,
            type = _form.type,
            description = _form.description;

        var formToSave = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          type: type
        }, this.form[type]);
        if (description) {
          formToSave.description = description;
        }
        this.saveNewTag({
          details: formToSave,
          videoId: this.$route.params.videoId
        });
      }
    }
  })
});

/***/ }),

/***/ "U7GS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"md-active":_vm.shouldDialogBeOpen,"md-close-on-esc":false,"md-click-outside-to-close":false},on:{"update:mdActive":function($event){_vm.shouldDialogBeOpen=$event},"md-closed":_vm.clearForm}},[(_vm.uploading)?_c('div',{staticClass:"overlay-progress"},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}})],1):_vm._e(),_c('md-dialog-title',[_vm._v(_vm._s(_vm.getDialogTitle))]),(_vm.images)?_c('img',{staticClass:"crop-image",attrs:{"src":_vm.images.cropped}}):_vm._e(),(_vm.isCurrentStageDialog)?_c('tag-form',{attrs:{"form":_vm.form,"$v":_vm.$v,"showDescription":true},on:{"update:form":function($event){_vm.form=$event}}}):_vm._e(),(_vm.isCurrentStageDialog)?_c('md-dialog-actions',[_c('md-button',{on:{"click":_vm.previousStage}},[_vm._v("Back")]),_c('md-button',{staticClass:"md-primary",on:{"click":_vm.submitForm}},[_vm._v("Create")])],1):_vm._e(),(_vm.isCurrentStageDone)?_c('div',[_c('md-dialog-content',[_vm._v("This tag has been successfully created!")]),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",on:{"click":_vm.nextStage}},[_vm._v("Done")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ve70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agency-card-container"},[_c('router-link',{attrs:{"to":_vm.getLinkToAgency(_vm.agency)}},[_c('div',{staticClass:"agency-card md-elevation-5"},[(_vm.agency.logo)?_c('img',{attrs:{"src":_vm.agency.logo}}):_vm._e(),_c('div',{staticClass:"overlay"})])]),_c('router-link',{staticClass:"name",attrs:{"to":_vm.getLinkToAgency(_vm.agency)}},[_vm._v(_vm._s(_vm.agency.name))]),_c('div',{staticClass:"event-count"},[_vm._v(_vm._s(_vm.eventCount))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VpG+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X4+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAgencyDialog_vue__ = __webpack_require__("+qWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064fa49c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewAgencyDialog_vue__ = __webpack_require__("aTxo");
function injectStyle (ssrContext) {
  __webpack_require__("mJpH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-064fa49c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewAgencyDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_064fa49c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewAgencyDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XZap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    isDrawerOpen: false,
    isNewAgencyDialogOpen: false,
    isNewEventDialogOpen: false,
    isNewVideoDialogOpen: false
  },
  mutations: {
    openDrawer: function openDrawer(state) {
      state.isDrawerOpen = true;
    },
    closeDrawer: function closeDrawer(state) {
      state.isDrawerOpen = false;
    },
    openNewAgencyDialog: function openNewAgencyDialog(state) {
      state.isNewAgencyDialogOpen = true;
    },
    closeNewAgencyDialog: function closeNewAgencyDialog(state) {
      state.isNewAgencyDialogOpen = false;
    },
    openNewEventDialog: function openNewEventDialog(state) {
      state.isNewEventDialogOpen = true;
    },
    closeNewEventDialog: function closeNewEventDialog(state) {
      state.isNewEventDialogOpen = false;
    },
    openNewVideoDialog: function openNewVideoDialog(state) {
      state.isNewVideoDialogOpen = true;
    },
    closeNewVideoDialog: function closeNewVideoDialog(state) {
      state.isNewVideoDialogOpen = false;
    }
  }
});

/***/ }),

/***/ "Y4Wj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YTLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__("uoDX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6f74fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__("mceU");
function injectStyle (ssrContext) {
  __webpack_require__("hGx0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab6f74fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6f74fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Home__ = __webpack_require__("HXef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Browse__ = __webpack_require__("fPYz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Agency__ = __webpack_require__("N4JW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Event__ = __webpack_require__("YTLV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Video__ = __webpack_require__("xzpI");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Home__["a" /* default */]
  }, {
    path: '/browse',
    redirect: '/browse/videos',
    name: 'browse',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Browse__["a" /* default */],
    children: [{
      path: 'videos',
      name: 'videos'
    }, {
      path: 'events',
      name: 'events'
    }, {
      path: 'agencies',
      name: 'agencies'
    }]
  }, {
    path: '/agency/:agencyId',
    name: 'agency',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Agency__["a" /* default */]
  }, {
    path: '/event/:eventId',
    name: 'event',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Event__["a" /* default */]
  }, {
    path: '/video/:videoId',
    name: 'video',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Video__["a" /* default */]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Z5On":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-drawer',{attrs:{"md-active":_vm.isDrawerOpen},on:{"update:mdActive":function($event){_vm.isDrawerOpen=$event}}},[(_vm.isSignedIn)?_c('md-list',{staticClass:"user-section md-double-line"},[_c('md-list-item',[_c('md-avatar',[_c('img',{attrs:{"src":_vm.user.photoURL}})]),_c('div',{staticClass:"md-list-item-text"},[_c('span',{staticClass:"display-name"},[_vm._v(_vm._s(_vm.user.displayName))]),_c('span',{staticClass:"email"},[_vm._v(_vm._s(_vm.user.email))])]),(_vm.isSignedIn)?_c('md-button',{staticClass:"md-raised",on:{"click":function($event){_vm.click(_vm.signOut)}}},[_vm._v("Sign out")]):_vm._e()],1)],1):_vm._e(),_c('md-divider'),_c('md-list',[_c('md-subheader',[_vm._v("Navigation")]),_c('md-list-item',{attrs:{"to":"/browse/videos"},on:{"click":function($event){_vm.click()}}},[_c('md-icon',[_vm._v("play_circle_filled")]),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Videos")])],1),_c('md-list-item',{attrs:{"to":"/browse/events"},on:{"click":function($event){_vm.click()}}},[_c('md-icon',[_vm._v("event")]),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Events")])],1),_c('md-list-item',{attrs:{"to":"/browse/agencies"},on:{"click":function($event){_vm.click()}}},[_c('md-icon',[_vm._v("people")]),_c('span',{staticClass:"md-list-item-text"},[_vm._v("Agencies")])],1)],1),_c('md-divider'),(_vm.isSignedIn && _vm.isUserInAnyAgency)?_c('md-list',[_c('md-subheader',[_vm._v("Your agencies")]),_vm._l((_vm.currentUsersAgencies),function(agency){return _c('md-list-item',{key:agency['.key'],attrs:{"to":_vm.getLinkToAgency(agency)},on:{"click":function($event){_vm.click()}}},[_c('span',[_vm._v(_vm._s(agency.name))]),(_vm.isCurrentUserAnAgencyAdmin(agency))?_c('kl-label',{attrs:{"text":"Admin"}}):_vm._e()],1)})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZXJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export youTube */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serverless; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var youTube = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://www.googleapis.com/youtube/v3',
  params: {
    key: Object({"NODE_ENV":"production"}).YOUTUBE_API_KEY
  }
});

var serverless = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://1oylt7v3hj.execute-api.eu-west-1.amazonaws.com/dev'
});

/***/ }),

/***/ "ZcaK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doTagsExist)?_c('div',{staticClass:"tag-list-container"},[_c('div',{staticClass:"tag-list-content"},[_c('div',{staticClass:"tag-list-header"},[_c('div',[_c('div',{staticClass:"tag-list-title"},[_vm._v(_vm._s(_vm.tagCountText))]),_c('div',{staticClass:"tag-list-subtitle"},[_vm._v(_vm._s(_vm.tagListHelpText))])]),_c('div',{style:({display: 'flex'})},[(_vm.filter.type)?_c('md-button',{staticClass:"md-raised",on:{"click":_vm.clearForm}},[_vm._v("Clear")]):_vm._e(),_c('md-button',{staticClass:"md-primary md-raised",on:{"click":function($event){_vm.isFilterDialogOpen = true}}},[_vm._v("Filter")])],1)]),_c('md-dialog',{attrs:{"md-active":_vm.isFilterDialogOpen},on:{"update:mdActive":function($event){_vm.isFilterDialogOpen=$event}}},[_c('md-dialog-title',[_vm._v("Filter tags")]),_c('tag-form',{attrs:{"form":_vm.filter,"clearable":true},on:{"update:form":function($event){_vm.filter=$event}}}),_c('md-dialog-actions',[_c('md-button',{on:{"click":_vm.clearForm}},[_vm._v("Clear")]),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.isFilterDialogOpen = false}}},[_vm._v("Done")])],1)],1),_c('md-table',{staticClass:"tag-list-table",attrs:{"md-sort":_vm.sortBy,"md-sort-order":_vm.sortOrder,"md-sort-fn":function (value) { return value; },"md-card":"md-card"},on:{"update:mdSort":function($event){_vm.sortBy=$event},"update:mdSortOrder":function($event){_vm.sortOrder=$event}},scopedSlots:_vm._u([{key:"md-table-row",fn:function(ref){
var item = ref.item;
return _c('md-table-row',{},[_c('md-table-cell',[(_vm.areTagsPlayable)?_c('router-link',{attrs:{"to":{path: _vm.getLinkToVideo(item.video), query: {tag: item.number}}}},[_c('md-button',{staticClass:"md-icon-button md-raised md-accent md-dense"},[_c('md-icon',[_vm._v("play_arrow")])],1)],1):_c('md-button',{staticClass:"md-icon-button md-raised md-accent md-dense",on:{"click":function($event){_vm.isTagPlaybackAlertOpen = true}}},[_c('md-icon',[_vm._v("play_arrow")])],1)],1),_c('md-table-cell',{attrs:{"md-label":"#","md-sort-by":"number"}},[_vm._v(_vm._s(("#" + (item.number))))]),_c('md-table-cell',{attrs:{"md-label":"Image"}},[_c('img',{staticClass:"thumbnail",attrs:{"src":item.crop.images.highlighted},on:{"click":function($event){_vm.showImage(item.number)}}})]),_c('md-table-cell',{attrs:{"md-label":"Start","md-sort-by":"start"}},[_vm._v(_vm._s(_vm.formatDuration(item.range.start)))]),_c('md-table-cell',{attrs:{"md-label":"End","md-sort-by":"end"}},[_vm._v(_vm._s(_vm.formatDuration(item.range.end)))]),_c('md-table-cell',{attrs:{"md-label":"Type","md-sort-by":"type"}},[_c('span',{staticClass:"filter-link",on:{"click":function($event){_vm.filter.type = item.details.type}}},[_vm._v(_vm._s(item.details.type))])]),(_vm.filter.type)?_vm._l((Object.keys(_vm.filter[_vm.filter.type])),function(subType){return _c('md-table-cell',{key:subType,attrs:{"md-label":_vm.capitalise(subType),"md-sort-by":subType}},[_c('span',{staticClass:"filter-link",on:{"click":function($event){_vm.filter[_vm.filter.type][subType] = item.details[subType]}}},[_vm._v(_vm._s(item.details[subType]))])])}):_vm._e(),_c('md-table-cell',{attrs:{"md-label":"Description","md-sort-by":"description"}},[_vm._v(_vm._s(item.details.description || '—'))])],2)}}]),model:{value:(_vm.visibleTags),callback:function ($$v) {_vm.visibleTags=$$v},expression:"visibleTags"}}),_c('md-dialog-alert',{attrs:{"md-active":_vm.isTagPlaybackAlertOpen,"md-title":"Cannot play tag","md-content":"An existing tag cannot be played while creating a new tag. Finish creating the tag or cancel the process, then try again.","md-confirm-text":"Understood"},on:{"update:mdActive":function($event){_vm.isTagPlaybackAlertOpen=$event}}}),(_vm.filteredTagImages)?_c('lightbox',{ref:"lightbox",attrs:{"images":_vm.filteredTagImages,"showLightBox":false,"showCaption":true}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a4Ue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__("yp89");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-card',

  props: ['event', 'image'],

  computed: {
    videoCount: function videoCount() {
      var count = this.countVideosInEvent(this.event);
      return count + ' ' + (count === 1 ? 'video' : 'videos');
    },
    tagCount: function tagCount() {
      var count = this.countTagsInEvent(this.event);
      return count + ' ' + (count === 1 ? 'tag' : 'tags');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["d" /* mapGettersWithParams */])({
    getLinkToEvent: 'event/getLinkToEvent',
    countVideosInEvent: 'event/countVideosInEvent',
    countTagsInEvent: 'event/countTagsInEvent'
  }))
});

/***/ }),

/***/ "aTxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"md-active":_vm.isNewAgencyDialogOpen,"md-close-on-esc":false,"md-click-outside-to-close":false},on:{"update:mdActive":function($event){_vm.isNewAgencyDialogOpen=$event},"md-closed":_vm.clearForm}},[_c('md-dialog-title',[_vm._v("Create new agency")]),_c('md-dialog-content',[_c('md-field',{class:_vm.getValidationClass('name')},[_c('label',{attrs:{"for":"agency-name"}},[_vm._v("Agency name")]),_c('md-input',{attrs:{"name":"agency-name"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),(!_vm.$v.form.name.required)?_c('span',{staticClass:"md-error"},[_vm._v("An agency must have a name.")]):(!_vm.$v.form.name.minLength)?_c('span',{staticClass:"md-error"},[_vm._v("Must be at least 3 letters long.")]):_vm._e()],1),_c('md-field',{class:_vm.getValidationClass('description')},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description")]),_c('md-textarea',{attrs:{"name":"description","md-counter":"800"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),(!_vm.$v.form.description.required)?_c('span',{staticClass:"md-error"},[_vm._v("An agency must have a description.")]):(!_vm.$v.form.name.maxLength)?_c('span',{staticClass:"md-error"},[_vm._v("Cannot be longer than 800 characters.")]):_vm._e()],1),_c('md-field',[_c('label',{attrs:{"for":"logo"}},[_vm._v("Logo")]),_c('md-file',{attrs:{"name":"logo","accept":"image/*"},on:{"change":_vm.handleImageChange}})],1),_c('div',{staticClass:"cropper"},[(_vm.image)?_c('vue-cropper',{ref:"cropper",attrs:{"src":_vm.image,"view-mode":0,"aspect-ratio":1,"guides":false,"center":false,"auto-crop":true,"auto-crop-area":1,"movable":false,"zoomable":false,"container-style":_vm.cropperContainerStyle}}):_vm._e()],1),_c('md-field',{class:_vm.getValidationClass('website')},[_c('label',{attrs:{"for":"website"}},[_vm._v("Website URL")]),_c('md-input',{attrs:{"website":"website"},model:{value:(_vm.form.website),callback:function ($$v) {_vm.$set(_vm.form, "website", $$v)},expression:"form.website"}}),(!_vm.$v.form.website.url)?_c('span',{staticClass:"md-error"},[_vm._v("Not a valid URL.")]):_vm._e()],1)],1),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-secondary",on:{"click":function($event){_vm.isNewAgencyDialogOpen = false}}},[_vm._v("Cancel")]),_c('md-button',{staticClass:"md-primary",on:{"click":_vm.submitForm}},[_vm._v("Create")])],1)],1),_c('md-snackbar',{attrs:{"md-active":_vm.showSnackbar,"md-duration":5000},on:{"update:mdActive":function($event){_vm.showSnackbar=$event}}},[_c('span',[_vm._v("Agency has been successfully created.")]),(_vm.newAgencyId)?_c('router-link',{attrs:{"to":_vm.getLinkToAgency(_vm.newAgencyId)}},[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.showSnackbar = false}}},[_vm._v("Go to agency")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "amq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video)?_c('div',{attrs:{"id":"video"}},[_c('video-tagger',{attrs:{"video":_vm.video}}),_c('video-info',{attrs:{"video":_vm.video,"event":_vm.event}}),_c('tag-list',{attrs:{"tags":_vm.tags}}),_c('new-tag-dialog')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b8Uq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cfFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoInfo_vue__ = __webpack_require__("5wBU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f76fc64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoInfo_vue__ = __webpack_require__("IKb/");
function injectStyle (ssrContext) {
  __webpack_require__("MGIb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f76fc64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f76fc64_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d3cY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-toolbar',[(_vm.isSignedIn)?_c('md-button',{staticClass:"md-icon-button",on:{"click":_vm.openDrawer}},[_c('md-icon',[_vm._v("menu")])],1):_vm._e(),_c('router-link',{staticClass:"md-title",attrs:{"to":"/"}},[_vm._v("Disaster Damage Video Tagger")]),(!_vm.isSignedIn)?_c('md-button',{on:{"click":_vm.signInWithGoogle}},[_vm._v("Sign in or register")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dPB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',

  data: function data() {
    return {
      tagline: 'Contribute to disaster relief from anywhere.',
      shortDescription: 'Help agencies manage emergencies by tagging videos of the event.',
      description: ['Thousands of videos are uploaded onto Twitter when a disaster strikes, showing the damage and destruction caused.\n         Such videos contain information that is very valuable to the agencies that manage the aftermath of the event.', 'However, many agencies lack the resources and manpower required to extract this information.', 'Disaster Damage Video Tagger aims to address this problem by allowing volunteers to submit and tag Twitter videos of the event.\n         This enables agencies to access valuable information that could greatly assist their relief effort.'],
      steps: ['Browse videos of recent disaster events, or submit your own.', 'Tag video frames that contain something of interest.', 'Categorise and describe what you\'ve tagged.', 'All submitted tags can be used by agencies to assist their relief effort.']
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    isSignedIn: 'auth/isSignedIn'
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    signInWithGoogle: 'auth/signInWithGoogle'
  }), {
    getStarted: function getStarted() {
      if (this.isSignedIn) {
        this.$router.push({ name: 'browse' });
      } else {
        this.signInWithGoogle();
      }
    }
  })
});

/***/ }),

/***/ "djO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__("4x6I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfe27880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__("d3cY");
function injectStyle (ssrContext) {
  __webpack_require__("k+Ll")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfe27880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfe27880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e5vl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyList_vue__ = __webpack_require__("QIXb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668b690e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyList_vue__ = __webpack_require__("1mS8");
function injectStyle (ssrContext) {
  __webpack_require__("HNQS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-668b690e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668b690e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eI/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ePeP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__("8m66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire__ = __webpack_require__("reQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuexfire__);





var eventsRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('events');
var agenciesRef = __WEBPACK_IMPORTED_MODULE_2__firebase__["b" /* db */].ref('agencies');

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    events: [],
    areEventsLoaded: false,
    areEventsLoading: false,
    newEventId: null // used for snackbar
  },

  getters: {
    doEventsExist: function doEventsExist(state) {
      return state.events.length > 0;
    },

    eventIdsByName: function eventIdsByName(state) {
      var eventIdsByName = {};
      state.events.forEach(function (event) {
        eventIdsByName[event.name] = event['.key'];
      });
      return eventIdsByName;
    },

    getEventById: function getEventById(state) {
      return function (eventId) {
        return state.events.find(function (event) {
          return event['.key'] === eventId;
        });
      };
    },

    getEventsByIds: function getEventsByIds(state, getters) {
      return function (eventIds) {
        var events = eventIds.map(function (eventId) {
          return getters.getEventById(eventId);
        });
        return events === {} ? null : events;
      };
    },

    getLinkToEvent: function getLinkToEvent() {
      return function (event) {
        if (typeof event === 'string') {
          return '/event/' + event;
        } else {
          return '/event/' + event['.key'];
        }
      };
    },

    getImage: function getImage(state, getters, rootState, rootGetters) {
      return function (event) {
        if (event && event.videos) {
          var videos = rootGetters['video/getVideosByIds'](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.videos));
          var randomVideo = videos[Math.floor(Math.random() * videos.length)];
          return randomVideo && randomVideo.thumbnail;
        }
      };
    },

    countVideosInEvent: function countVideosInEvent() {
      return function (event) {
        return event && event.videos ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.videos).length : 0;
      };
    },

    countTagsInEvent: function countTagsInEvent(state, getters, rootState, rootGetters) {
      return function (event) {
        if (event.videos) {
          var videoIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.videos);
          var tags = rootGetters['tag/getTagsByVideoIds'](videoIds);
          return tags.length;
        }
        return 0;
      };
    }
  },

  mutations: {
    setAreEventsLoaded: function setAreEventsLoaded(state) {
      state.areEventsLoading = false;
      state.areEventsLoaded = true;
    },
    setAreEventsLoading: function setAreEventsLoading(state) {
      state.areEventsLoading = true;
    },
    setNewEventId: function setNewEventId(state, value) {
      state.newEventId = value;
    }
  },

  actions: {
    setEventsRef: Object(__WEBPACK_IMPORTED_MODULE_3_vuexfire__["firebaseAction"])(function (_ref, _ref2) {
      var bindFirebaseRef = _ref.bindFirebaseRef;
      var ref = _ref2.ref,
          commit = _ref2.commit;

      bindFirebaseRef('events', ref, {
        readyCallback: function readyCallback() {
          commit('setAreEventsLoaded');
        }
      });
    }),

    loadEvents: function loadEvents(_ref3) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;

      if (!state.areEventsLoaded && !state.areEventsLoading) {
        commit('setAreEventsLoading');
        dispatch('setEventsRef', { ref: eventsRef, commit: commit });
      }
    },
    saveNewEvent: function saveNewEvent(_ref4, _ref5) {
      var commit = _ref4.commit;
      var event = _ref5.event;

      // save event
      var newEventRef = eventsRef.push();
      var newEventId = newEventRef.key;
      commit('setNewEventId', newEventId);
      newEventRef.set(event);
      // save agencies
      var eventIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(event.agencies);
      eventIds.forEach(function (agencyId) {
        agenciesRef.child(agencyId).child('events').update(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, newEventId, true));
      });
    }
  }
});

/***/ }),

/***/ "eQ72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-speed-dial',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    openNewAgencyDialog: 'ui/openNewAgencyDialog',
    openNewEventDialog: 'ui/openNewEventDialog',
    openNewVideoDialog: 'ui/openNewVideoDialog'
  }))
});

/***/ }),

/***/ "f825":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-container md-elevation-5"},[_c('div',{staticClass:"label-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fFb9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs__ = __webpack_require__("4RJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cropperjs__);






var createTagButton = void 0;
var cropper = void 0;
var canvas = void 0;
var canvasContainer = void 0;
var rangeNavigationButtons = void 0;
var cropTimeMarker = void 0;
var rangeBar = void 0;
var rangeHandle = void 0;
var infoBar = void 0;
var infoBarContent = void 0;
var closeTagButton = void 0;
var rangeTooltip = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-tagger',

  props: ['video'],

  data: function data() {
    return {
      url: this.video && this.video.url, // required since options on vue-video-player is not reactive
      tagId: null // if not null, tag playback is enabled
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    stage: function stage(state) {
      return state.tag.stage;
    },
    crop: function crop(state) {
      return state.tag.crop;
    },
    range: function range(state) {
      return state.tag.range;
    },
    lastStageIndex: function lastStageIndex(state) {
      return state.tag.lastStageIndex;
    },
    areTagsLoaded: function areTagsLoaded(state) {
      return state.tag.areTagsLoaded;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    currentStageName: 'tag/currentStageName'
  }), {
    playerOptions: function playerOptions() {
      return {
        sources: {
          type: 'application/x-mpegURL',
          src: this.url
        },
        muted: true,
        controlBar: {
          volumePanel: false
        },
        playbackRates: [0.25, 0.5, 1.0, 2.0]
      };
    },
    infoText: function infoText() {
      if (this.tag) return 'Currently playing tag #' + this.tag.number + '.';
      var name = this.currentStageName;
      if (name === 'play') return 'When you spot something, pause the video to create a new tag.';
      if (name === 'crop') return 'Drag and resize the box to cover what you want to tag.';
      if (name === 'range-start') return 'Navigate the video to when the tag enters the frame.';else return 'Navigate the video to when the tag leaves the frame.';
    },

    // tag to be played
    tag: function tag() {
      if (this.tagId && this.areTagsLoaded) {
        return this.getTagById(this.tagId);
      }
    }
  }),

  destroyed: function destroyed() {
    this.resetTagger();
  },


  watch: {
    video: function video(newVideo) {
      if (newVideo) {
        this.url = newVideo.url; // required since options on vue-video-player is not reactive
      }
    },
    $route: function $route(_$route) {
      var tag = _$route.query.tag;

      if (tag) {
        this.checkTagQuery();
      } else {
        this.tagId = null;
      }
    },
    tag: function tag(_tag) {
      if (_tag) {
        this.player().currentTime(this.tag.range.start);
        this.player().play();
        this.show(rangeBar);
        this.setRangeBarToTag(_tag);
        this.show(cropTimeMarker);
        this.setCropTimeMarkerToTag(_tag);
        this.show(rangeTooltip);
        this.setRangeTooltipToTag(_tag);
        this.hide(this.playProgress());
        this.show(closeTagButton);
        window.scroll(0, 0);
      } else {
        this.hide(rangeBar);
        this.resetRangeBar();
        this.hide(cropTimeMarker);
        this.show(this.playProgress());
        this.hide(closeTagButton);
      }
    },
    infoText: function infoText(_infoText) {
      infoBarContent.innerText = _infoText;
    },
    stage: function stage(newStage, oldStage) {
      var newStageName = this.getStageName(newStage);
      var oldStageName = this.getStageName(oldStage);
      var restarted = newStage === 0 && oldStage === this.lastStageIndex;
      var clickedNext = restarted || oldStage < newStage;

      var entered = function entered(stageName) {
        return newStageName === stageName;
      };
      var left = function left(stageName) {
        return oldStageName === stageName;
      };

      if (left('play')) {
        this.hide(createTagButton);
        if (this.tag) this.$router.push(this.$route.path); // stop tag playback
      }
      if (entered('play')) {
        this.show(createTagButton);
      }

      if (clickedNext) {
        // clicked 'next'
        if (entered('crop')) {
          this.startCrop();
        }
        if (left('crop')) {
          this.saveCrop();
        }
        if (entered('range-start')) {
          this.startRangeStart();
        }
        if (left('range-start')) {
          this.saveRangeStart();
        }
        if (entered('range-end')) {
          this.startRangeEnd();
        }
        if (left('range-end')) {
          this.saveRangeEnd();
        }
        if (entered('dialog')) {
          this.player().exitFullscreen();
        }
        if (entered('play')) {
          this.resetTagger();
          this.endRange();
        }
      } else {
        // clicked 'back'
        if (left('crop')) {
          this.cancelCrop();
        }
        if (entered('crop')) {
          this.resumeCrop();
        }
        if (left('range-start')) {
          this.cancelRangeStart();
        }
        if (entered('range-start')) {
          this.resumeRangeStart();
        }
        if (left('range-end')) {
          this.cancelRangeEnd();
        }
        if (entered('range-end')) {
          this.resumeRangeEnd();
        }
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    nextStage: 'tag/nextStage',
    previousStage: 'tag/previousStage',
    setCrop: 'tag/setCrop',
    clearCrop: 'tag/clearCrop',
    setRangeStart: 'tag/setRangeStart',
    setRangeEnd: 'tag/setRangeEnd',
    clearRangeStart: 'tag/clearRangeStart',
    clearRangeEnd: 'tag/clearRangeEnd',
    resetTagger: 'tag/resetTagger'
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getTagIdInVideo: 'video/getTagIdInVideo',
    getTagById: 'tag/getTagById',
    getStageName: 'tag/getStageName'
  }), {

    // player event listeners
    playerReady: function playerReady() {
      this.buildInitialUI();
    },
    playerTimeUpdated: function playerTimeUpdated(player) {
      // update range bar
      if (this.currentStageName === 'range-start') {
        this.updateRangeBarOnNewStart();
      }
      if (this.currentStageName === 'range-end') {
        this.updateRangeBarOnNewEnd();
      }
      // restart tag range
      if (this.tag) {
        var time = player.currentTime();
        var _tag$range = this.tag.range,
            start = _tag$range.start,
            end = _tag$range.end;

        if (time < start || end < time) {
          player.currentTime(start);
          player.pause();
        }
      }
    },
    playerLoadedData: function playerLoadedData() {
      this.checkTagQuery();
    },


    // frequently-accessed elements
    videojs: function videojs() {
      return document.getElementsByClassName('video-js')[0];
    },
    cropBox: function cropBox() {
      return document.getElementsByClassName('cropper-crop-box')[0];
    },
    videoElement: function videoElement() {
      return this.player().children_[0];
    },
    slider: function slider() {
      return document.getElementsByClassName('vjs-slider')[0];
    },
    player: function player() {
      return this.$refs.videoPlayer.player;
    },
    playProgress: function playProgress() {
      return document.getElementsByClassName('vjs-play-progress')[0];
    },
    controlBar: function controlBar() {
      return document.getElementsByClassName('vjs-control-bar')[0];
    },
    playbackRateControl: function playbackRateControl() {
      return document.getElementsByClassName('vjs-playback-rate')[0];
    },


    // slider bar percentages
    currentTimePercentage: function currentTimePercentage() {
      return this.timeAsPercentage(this.player().currentTime());
    },
    cropTimePercentage: function cropTimePercentage() {
      if (this.crop && this.crop.time) {
        return this.timeAsPercentage(this.crop.time);
      } else {
        return 0;
      }
    },
    startTimePercentage: function startTimePercentage() {
      if (this.range && this.range.start) {
        return this.timeAsPercentage(this.range.start);
      } else {
        return 0;
      }
    },
    timeAsPercentage: function timeAsPercentage(time) {
      return time / this.player().duration();
    },
    percentageAsString: function percentageAsString(percentage) {
      return percentage * 100 + '%';
    },


    // element visibility
    show: function show(element) {
      element.classList.remove('hide');
    },
    hide: function hide(element) {
      element.classList.add('hide');
    },


    // button generators
    buildButton: function buildButton(_ref) {
      var className = _ref.className,
          label = _ref.label,
          onClick = _ref.onClick;

      var button = document.createElement('div');
      button.classList.add('vjs-tagger-button');
      if (className) button.classList.add(className);
      button.innerText = label;
      button.addEventListener('click', onClick);
      return button;
    },
    buildNextButton: function buildNextButton(_ref2) {
      var _this = this;

      var className = _ref2.className,
          label = _ref2.label;

      return this.buildButton({
        className: className,
        label: label || 'Next',
        onClick: function onClick(event) {
          event.stopPropagation();
          _this.nextStage();
        }
      });
    },
    buildBackButton: function buildBackButton(_ref3) {
      var _this2 = this;

      var className = _ref3.className,
          label = _ref3.label;

      return this.buildButton({
        className: className,
        label: label || 'Back',
        onClick: function onClick(event) {
          event.stopPropagation();
          _this2.previousStage();
        }
      });
    },
    buildNavigationButtons: function buildNavigationButtons(_ref4) {
      var className = _ref4.className,
          hideBack = _ref4.hideBack,
          nextLabel = _ref4.nextLabel;

      var navigationButtons = document.createElement('div');
      navigationButtons.className = 'vjs-navigation-buttons ' + className;
      if (!hideBack) {
        var backButton = this.buildBackButton({});
        navigationButtons.appendChild(backButton);
      }
      var nextButton = this.buildNextButton({
        label: nextLabel
      });
      navigationButtons.appendChild(nextButton);
      return navigationButtons;
    },


    // info bar
    buildInfoBar: function buildInfoBar() {
      // info bar container
      infoBar = document.createElement('div');
      infoBar.classList.add('vjs-info-bar');
      // info bar content
      infoBarContent = document.createElement('span');
      infoBarContent.innerText = this.infoText;
      infoBar.appendChild(infoBarContent);
      // close tag button
      closeTagButton = document.createElement('span');
      closeTagButton.classList.add('vjs-close-tag-button');
      closeTagButton.innerText = 'Stop';
      var context = this;
      closeTagButton.addEventListener('click', function () {
        context.$router.push(context.$route.path);
      });
      infoBar.appendChild(closeTagButton);
      this.hide(closeTagButton);
      // add to video player
      this.videojs().appendChild(infoBar);
    },

    // tag playback
    checkTagQuery: function checkTagQuery() {
      var tagNumber = parseInt(this.$route.query.tag, 10);
      var tagId = this.getTagIdInVideo(this.video, tagNumber);
      if (tagId && this.currentStageName === 'play') {
        this.tagId = tagId;
      } else {
        this.$router.replace(this.$route.path);
      }
    },

    // frame-by-frame controls
    buildFrameByFrameControls: function buildFrameByFrameControls() {
      // create buttons
      var backFrame = document.createElement('button');
      var forwardFrame = document.createElement('button');
      backFrame.classList.add('vjs-button', 'vjs-control', 'vjs-frame-control');
      forwardFrame.classList.add('vjs-button', 'vjs-control', 'vjs-frame-control');
      backFrame.innerText = '-1';
      forwardFrame.innerText = '+1';
      // click listeners
      var player = this.player;
      backFrame.addEventListener('click', function () {
        player().currentTime(player().currentTime() - 0.05);
      });
      forwardFrame.addEventListener('click', function () {
        player().currentTime(player().currentTime() + 0.05);
      });
      // insert buttons into control bar
      this.controlBar().insertBefore(backFrame, this.playbackRateControl());
      this.controlBar().insertBefore(forwardFrame, this.playbackRateControl());
    },
    buildPlayProgressMarker: function buildPlayProgressMarker() {
      // marker
      var marker = document.createElement('div');
      marker.classList.add('vjs-play-progress-marker');
      // add to player
      this.playProgress().appendChild(marker);
    },


    // initialise player UI
    buildInitialUI: function buildInitialUI() {
      this.buildPlayProgressMarker();
      this.buildFrameByFrameControls();
      this.buildCanvas();
      this.buildCreateTagButton();
      this.buildRangeNavigationButtons();
      this.buildRangeBar();
      this.buildRangeHandle();
      this.buildCropTimeMarker();
      this.buildInfoBar();
    },


    // playback
    buildCreateTagButton: function buildCreateTagButton() {
      createTagButton = this.buildNavigationButtons({
        className: 'vjs-center-buttons vjs-create-tag-button',
        nextLabel: 'Create a new tag',
        hideBack: true
      });
      this.videojs().appendChild(createTagButton);
    },


    // cropping
    buildCanvas: function buildCanvas() {
      canvasContainer = document.createElement('div');
      canvasContainer.className = 'vjs-canvas-container hide';
      canvas = document.createElement('canvas');
      canvas.className = 'vjs-canvas';
      canvas.width = 0;
      canvas.height = 0;
      canvasContainer.appendChild(canvas);
      this.videojs().appendChild(canvasContainer);
    },
    buildCropper: function buildCropper(crop) {
      var _this3 = this;

      this.show(canvasContainer);
      var cropperNavigationButtons = this.buildNavigationButtons({
        className: 'vjs-cropper-navigation-buttons'
      });
      var onReady = function onReady() {
        _this3.cropBox().appendChild(cropperNavigationButtons);
      };
      cropper = new __WEBPACK_IMPORTED_MODULE_3_cropperjs___default.a(canvas, {
        viewMode: 1,
        dragMode: 'move',
        guides: false,
        center: false,
        background: false,
        rotatable: false,
        scalable: false,
        toggleDragModeOnDblclick: false,
        autoCropArea: 0.5,

        data: crop, // load existing crop if it exists
        ready: onReady
      });
    },
    captureFullFrame: function captureFullFrame() {
      var context = canvas.getContext('2d');
      canvas.width = parseInt(this.videoElement().videoWidth);
      canvas.height = parseInt(this.videoElement().videoHeight);
      context.drawImage(this.videoElement(), 0, 0, canvas.width, canvas.height);
    },
    captureCroppedImage: function captureCroppedImage(_ref5) {
      var x = _ref5.x,
          y = _ref5.y,
          width = _ref5.width,
          height = _ref5.height;

      var cropCanvas = document.createElement('canvas'); // not rendered
      var context = cropCanvas.getContext('2d');
      cropCanvas.width = width;
      cropCanvas.height = height;
      context.drawImage(canvas, -x, -y, canvas.width, canvas.height);
      return cropCanvas.toDataURL('image/jpeg');
    },
    captureHighlightedImage: function captureHighlightedImage(_ref6) {
      var x = _ref6.x,
          y = _ref6.y,
          width = _ref6.width,
          height = _ref6.height;

      // copy full frame into new canvas
      var highlightCanvas = document.createElement('canvas'); // not rendered
      var context = highlightCanvas.getContext('2d');
      highlightCanvas.width = canvas.width;
      highlightCanvas.height = canvas.height;
      context.drawImage(canvas, 0, 0, canvas.width, canvas.height);

      // draw dark overlay
      context.globalAlpha = 0.5;
      context.fillStyle = 'black';
      context.fillRect(0, 0, x, canvas.height); // left bar
      context.fillRect(x + width, 0, canvas.width - x + width, canvas.height); // right bar
      context.fillRect(x, 0, width, y); // top bar
      context.fillRect(x, y + height, width, canvas.height - y - height); // bottom bar

      // draw lines
      context.strokeStyle = 'white';
      context.lineWidth = 2;
      context.strokeRect(x, 0, 0, canvas.height);
      context.strokeRect(x + width, 0, 0, canvas.height);
      context.strokeRect(0, y, canvas.width, 0);
      context.strokeRect(0, y + height, canvas.width, 0);

      return highlightCanvas.toDataURL('image/jpeg');
    },
    startCrop: function startCrop() {
      this.captureFullFrame();
      this.buildCropper();
      this.hide(this.controlBar());
    },
    saveCrop: function saveCrop() {
      var cropData = cropper.getData(true);
      this.setCrop({
        position: cropData,
        time: this.player().currentTime(),
        images: {
          cropped: this.captureCroppedImage(cropData),
          highlighted: this.captureHighlightedImage(cropData)
        }
      });
      this.endCrop();
      this.show(this.controlBar());
    },
    cancelCrop: function cancelCrop() {
      this.endCrop();
      this.clearCrop();
      this.show(this.controlBar());
    },
    resumeCrop: function resumeCrop() {
      this.buildCropper(this.crop.position);
      this.player().currentTime(this.crop.time);
      this.hide(this.controlBar());
    },
    endCrop: function endCrop() {
      cropper.destroy();
      this.hide(canvasContainer);
    },


    // range selection
    buildRangeNavigationButtons: function buildRangeNavigationButtons() {
      rangeNavigationButtons = this.buildNavigationButtons({
        className: 'vjs-center-buttons vjs-range-navigation-buttons'
      });
      this.videojs().appendChild(rangeNavigationButtons);
      this.hide(rangeNavigationButtons);
    },
    buildCropTimeMarker: function buildCropTimeMarker() {
      cropTimeMarker = document.createElement('div');
      cropTimeMarker.classList.add('vjs-crop-time-marker');
      this.slider().appendChild(cropTimeMarker);
      this.hide(cropTimeMarker);
    },
    buildRangeBar: function buildRangeBar() {
      // range bar
      rangeBar = document.createElement('div');
      rangeBar.classList.add('vjs-range-bar');
      // range tooltip
      rangeTooltip = document.createElement('div');
      rangeTooltip.classList.add('vjs-range-tooltip');
      rangeBar.appendChild(rangeTooltip);
      // add bar to player
      this.hide(rangeBar);
      this.slider().appendChild(rangeBar);
    },
    buildRangeHandle: function buildRangeHandle() {
      // handle
      rangeHandle = document.createElement('div');
      rangeHandle.classList.add('vjs-progress-handle');
      // icon
      rangeHandle.innerText = '↔';
      // add to player
      this.playProgress().appendChild(rangeHandle);
      this.hide(rangeHandle);
    },
    updateRangeBarOnNewStart: function updateRangeBarOnNewStart() {
      // don't allow times beyond crop time to be selected
      if (this.player().currentTime() > this.crop.time) {
        this.player().currentTime(this.crop.time);
      }
      rangeBar.style.left = this.percentageAsString(this.currentTimePercentage());
      rangeBar.style.width = this.percentageAsString(this.cropTimePercentage() - this.currentTimePercentage());
    },
    updateRangeBarOnNewEnd: function updateRangeBarOnNewEnd() {
      // don't allow times before crop time to be selected
      if (this.player().currentTime() < this.crop.time) {
        this.player().currentTime(this.crop.time);
      }
      rangeBar.style.width = this.percentageAsString(this.currentTimePercentage() - this.startTimePercentage());
    },
    resetRangeBar: function resetRangeBar() {
      rangeBar.style.width = 0;
    },
    startRangeStart: function startRangeStart() {
      this.show(rangeNavigationButtons);
      this.show(cropTimeMarker);
      this.show(rangeBar);
      this.show(rangeHandle);
      this.hide(this.playProgress());
      var leftPercentage = this.percentageAsString(this.cropTimePercentage());
      rangeBar.style.left = leftPercentage;
      cropTimeMarker.style.left = leftPercentage;
      rangeTooltip.innerText = 'Select range';
    },
    startRangeEnd: function startRangeEnd() {
      this.player().currentTime(this.crop.time);
    },
    saveRangeStart: function saveRangeStart() {
      this.setRangeStart(this.player().currentTime());
    },
    saveRangeEnd: function saveRangeEnd() {
      this.setRangeEnd(this.player().currentTime());
    },
    cancelRangeStart: function cancelRangeStart() {
      this.endRange();
      this.clearRangeStart();
    },
    cancelRangeEnd: function cancelRangeEnd() {
      this.clearRangeEnd();
    },
    resumeRangeStart: function resumeRangeStart() {
      this.player().currentTime(this.range.start);
    },
    resumeRangeEnd: function resumeRangeEnd() {
      this.player().currentTime(this.range.end);
    },
    endRange: function endRange() {
      this.hide(rangeNavigationButtons);
      this.hide(cropTimeMarker);
      this.hide(rangeBar);
      this.hide(rangeHandle);
      this.show(this.playProgress());
      this.resetRangeBar();
    },


    // range bar when tagging
    setRangeBarToTag: function setRangeBarToTag(tag) {
      var leftPercentage = this.timeAsPercentage(tag.range.start);
      var widthPercentage = this.timeAsPercentage(tag.range.end) - leftPercentage;
      rangeBar.style.left = this.percentageAsString(leftPercentage);
      rangeBar.style.width = this.percentageAsString(widthPercentage);
    },
    setCropTimeMarkerToTag: function setCropTimeMarkerToTag(tag) {
      cropTimeMarker.style.left = this.percentageAsString(this.timeAsPercentage(tag.crop.time));
    },
    setRangeTooltipToTag: function setRangeTooltipToTag(tag) {
      rangeTooltip.innerText = 'Tag #' + tag.number;
    }
  })
});

/***/ }),

/***/ "fPYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__ = __webpack_require__("uUN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce7b0b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__ = __webpack_require__("KMRE");
function injectStyle (ssrContext) {
  __webpack_require__("I7c+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ce7b0b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Browse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce7b0b3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Browse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fbZV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCard_vue__ = __webpack_require__("p3sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5a8d1a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCard_vue__ = __webpack_require__("Mtwn");
function injectStyle (ssrContext) {
  __webpack_require__("LPMx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5a8d1a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5a8d1a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fn2C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",attrs:{"to":_vm.getLinkToEvent(_vm.event)}},[_c('div',{staticClass:"event-card md-elevation-5"},[(_vm.image)?_c('img',{staticClass:"image",attrs:{"src":_vm.image}}):_vm._e(),_c('div',{staticClass:"overlay",class:{'overlay-no-image': !_vm.image}}),_c('div',{staticClass:"name",class:{'text-no-image': !_vm.image}},[_vm._v(_vm._s(_vm.event.name))]),_c('div',{staticClass:"statistics",class:{'text-no-image': !_vm.image}},[_vm._v(_vm._s(_vm.videoCount)+"\n • \n"+_vm._s(_vm.tagCount))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gh+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'agency-card',

  props: ['agency'],

  computed: {
    eventCount: function eventCount() {
      var count = this.agency.events ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.agency.events).length : 0;
      return count + ' ' + (count === 1 ? 'event' : 'events');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getLinkToAgency: 'agency/getLinkToAgency'
  }))
});

/***/ }),

/***/ "hC2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoTagger_vue__ = __webpack_require__("fFb9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e9f2cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoTagger_vue__ = __webpack_require__("MH9F");
function injectStyle (ssrContext) {
  __webpack_require__("wZO3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoTagger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e9f2cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoTagger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hGx0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hKkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.agency)?_c('div',{staticClass:"agency"},[_c('agency-header',{attrs:{"agency":_vm.agency}}),_c('md-tabs',{staticClass:"md-primary",attrs:{"md-alignment":"centered"},on:{"md-changed":_vm.handleTabChange}},[_c('md-tab',{attrs:{"id":"events","md-label":"Events"}}),_c('md-tab',{attrs:{"id":"members","md-label":"Members"}})],1),(_vm.activeTab === 'events')?_c('event-list',{attrs:{"events":_vm.events}}):_vm._e(),_c('add-speed-dial')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iQwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tweet-card-container"},[_c('div',{staticClass:"tweet-card md-elevation-5"},[(_vm.tweet)?_c('div',[_c('a',{staticClass:"link",attrs:{"href":_vm.tweet.webpage_url}},[_c('div',{staticClass:"tweet-preview"},[_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.tweet.thumbnail}}),_c('div',{staticClass:"text-section"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.tweet.title))]),_c('div',{staticClass:"handle"},[_vm._v("@"+_vm._s(_vm.tweet.uploader_id))])]),_c('div',{staticClass:"overlay"})])])]):_vm._e(),_c('div',{staticClass:"spinner-overlay"},[(_vm.loading)?_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j1yL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.doEventsExist && _vm.areEventsLoaded)?_c('md-empty-state',{attrs:{"md-icon":"event","md-label":"No events right now","md-description":"As soon as an event occurs, it will appear here."}},[_c('md-button',{staticClass:"md-raised md-primary",on:{"click":_vm.openNewEventDialog}},[_vm._v("Create new event")])],1):_vm._e(),(_vm.doEventsExist)?_c('div',{staticClass:"event-list"},_vm._l((_vm.events),function(event){return _c('event-card',{key:event['.key'],attrs:{"event":event,"image":_vm.getImage(event)}})})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jrjd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewVideoDialog_vue__ = __webpack_require__("24IH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c8012e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewVideoDialog_vue__ = __webpack_require__("sKcQ");
function injectStyle (ssrContext) {
  __webpack_require__("6nDn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11c8012e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewVideoDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11c8012e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewVideoDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k+Ll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kBqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoList_vue__ = __webpack_require__("Raba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04435484_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoList_vue__ = __webpack_require__("13ja");
function injectStyle (ssrContext) {
  __webpack_require__("6EKJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04435484"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04435484_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_VideoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kTCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUserLoaded)?_c('div',{attrs:{"id":"app"}},[_c('toolbar'),_c('drawer'),_c('new-agency-dialog'),_c('new-event-dialog'),_c('new-video-dialog'),_c('div',{attrs:{"id":"content"}},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lGuZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

window.videojs = __webpack_require__("Dia2");
videojs = videojs.default || videojs;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-player',
  props: {
    options: {
      type: Object,
      required: true
    },
    start: {
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    playsinline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    customEventName: {
      type: String,
      default: function _default() {
        return 'statechanged';
      }
    }
  },
  mounted: function mounted() {
    if (!this.player) {
      this.initialize();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.player) {
      this.dispose();
    }
  },
  methods: {
    initialize: function initialize() {

      // init
      var self = this;
      this.player = null;

      // videojs options
      var videoOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        autoplay: false,
        controls: true,
        preload: 'auto',
        fluid: false,
        muted: false,
        width: '100%',
        height: '360',
        language: 'en',
        controlBar: {
          remainingTimeDisplay: false,
          playToggle: {},
          progressControl: {},
          fullscreenToggle: {},
          volumeMenuButton: {
            inline: false,
            vertical: true
          }
        },
        techOrder: ['html5'],
        plugins: {}
      }, this.options);

      // check sources
      /*
      if (!videoOptions.sources || !videoOptions.sources.length) {
        console.warn('Missing required option: "sources".')
        return false
      }
      */

      // ios fullscreen
      var playsinline = this.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      // emit event
      var emitPlayerState = function emitPlayerState(event, value) {
        if (event) {
          self.$emit(event, self.player);
        }
        if (value) {
          var values = {};
          values[event] = value;
          self.$emit(self.customEventName, values);
        }
      };

      // videoOptions
      // console.log(videoOptions)

      // avoid error "VIDEOJS: ERROR: Unable to find plugin: __ob__"
      if (videoOptions.plugins) {
        delete videoOptions.plugins.__ob__;
      }

      this.player = videojs(this.$el.children[0], videoOptions, function () {

        // player readied
        var _this = this;
        self.$emit('ready', self.player);

        // events
        var events = ['loadeddata', 'canplay', 'canplaythrough', 'play', 'pause', 'waiting', 'playing', 'ended', 'error'];
        for (var i = 0; i < events.length; i++) {
          (function (event) {
            _this.on(event, function () {
              emitPlayerState(event, true);
            });
          })(events[i]);
        }

        this.on('timeupdate', function () {
          emitPlayerState('timeupdate', this.currentTime());
        });
      });
    },
    dispose: function dispose() {
      if (this.player && videojs) {
        if (this.player.techName_ !== 'Flash') {
          this.player.pause && this.player.pause();
        }
        videojs(this.$el.children[0]).dispose();
        if (!this.$el.children.length) {
          var video = document.createElement('video');
          video.className = 'video-js';
          this.$el.appendChild(video);
        }
        this.player = null;
      }
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      }
    }
  }
});

/***/ }),

/***/ "ligT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{staticClass:"md-primary"},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))]),_c('span',{attrs:{"id":"message"}},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mJpH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mceU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.event)?_c('div',{staticClass:"event"},[_c('event-header',{attrs:{"event":_vm.event,"agencies":_vm.agencies,"image":_vm.image}}),_c('md-tabs',{staticClass:"md-primary",attrs:{"md-alignment":"centered"},on:{"md-changed":_vm.handleTabChange}},[_c('md-tab',{attrs:{"id":"videos","md-label":"Videos"}}),_c('md-tab',{attrs:{"id":"tags","md-label":"Tags"}})],1),(_vm.activeTab === 'videos')?_c('video-list',{attrs:{"videos":_vm.videos}}):_vm._e(),(_vm.tags && (_vm.activeTab === 'tags'))?_c('tag-list',{attrs:{"tags":_vm.tags}}):_vm._e(),_c('add-speed-dial')],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p+gE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEventDialog_vue__ = __webpack_require__("xXYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a29af6e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewEventDialog_vue__ = __webpack_require__("8s9h");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewEventDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a29af6e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewEventDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p3sW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Label__ = __webpack_require__("+iuj");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'video-card',

  components: {
    'kl-label': __WEBPACK_IMPORTED_MODULE_2__components_Label__["a" /* default */]
  },

  props: ['video', 'event'],

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["d" /* mapGettersWithParams */])({
    getLinkToVideo: 'video/getLinkToVideo',
    getLinkToEvent: 'event/getLinkToEvent',
    countTagsInVideo: 'video/countTagsInVideo'
  })),

  computed: {
    tagCount: function tagCount() {
      var count = this.countTagsInVideo(this.video);
      return count + ' ' + (count === 1 ? 'tag' : 'tags');
    }
  }
});

/***/ }),

/***/ "pywU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qLZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebase__ = __webpack_require__("8m66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuexfire__ = __webpack_require__("reQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuexfire__);







var videosRef = __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* db */].ref('videos');
var eventsRef = __WEBPACK_IMPORTED_MODULE_4__firebase__["b" /* db */].ref('events');

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,

  state: {
    videos: [],
    areVideosLoaded: false,
    areVideosLoading: false,
    newVideoId: null // used for snackbar
  },

  getters: {
    doVideosExist: function doVideosExist(state) {
      return state.videos.length > 0;
    },

    getVideoById: function getVideoById(state) {
      return function (videoId) {
        return state.videos.find(function (video) {
          return video['.key'] === videoId;
        });
      };
    },

    getVideosByIds: function getVideosByIds(state, getters) {
      return function (videoIds) {
        var videos = videoIds.map(function (videoId) {
          return getters.getVideoById(videoId);
        });
        return videos === {} ? null : videos;
      };
    },

    getLinkToVideo: function getLinkToVideo() {
      return function (video) {
        if (typeof video === 'string') {
          return '/video/' + video;
        } else {
          return '/video/' + video['.key'];
        }
      };
    },

    countTagsInVideo: function countTagsInVideo(state, getters) {
      return function (video) {
        // resolve if video param is videoId
        var videoObject = typeof video === 'string' ? getters.getVideoById(video) : video;
        return videoObject && videoObject.tags ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(videoObject.tags).length : 0;
      };
    },

    getTagIdInVideo: function getTagIdInVideo() {
      return function (video, tagNumber) {
        if (video && tagNumber) {
          var tagEntry = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(video.tags).find(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                tagId = _ref2[0],
                tagNum = _ref2[1];

            return tagNum === tagNumber;
          });
          if (tagEntry) {
            var _tagEntry = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(tagEntry, 1),
                tagId = _tagEntry[0];

            return tagId;
          }
        } else {
          return null;
        }
      };
    }
  },

  mutations: {
    setAreVideosLoaded: function setAreVideosLoaded(state) {
      state.areVideosLoading = false;
      state.areVideosLoaded = true;
    },
    setAreVideosLoading: function setAreVideosLoading(state) {
      state.areVideosLoading = true;
    },
    setNewVideoId: function setNewVideoId(state, value) {
      state.newVideoId = value;
    }
  },

  actions: {
    setVideosRef: Object(__WEBPACK_IMPORTED_MODULE_5_vuexfire__["firebaseAction"])(function (_ref3, _ref4) {
      var bindFirebaseRef = _ref3.bindFirebaseRef;
      var ref = _ref4.ref,
          commit = _ref4.commit;

      bindFirebaseRef('videos', ref, {
        readyCallback: function readyCallback() {
          commit('setAreVideosLoaded');
        }
      });
    }),

    loadVideos: function loadVideos(_ref5) {
      var dispatch = _ref5.dispatch,
          commit = _ref5.commit,
          state = _ref5.state;

      if (!state.areVideosLoaded && !state.areVideosLoading) {
        commit('setAreVideosLoading');
        dispatch('setVideosRef', { ref: videosRef, commit: commit });
      }
    },
    saveNewVideo: function saveNewVideo(_ref6, _ref7) {
      var commit = _ref6.commit;
      var video = _ref7.video;

      // save video
      var newVideoRef = videosRef.push();
      var newVideoId = newVideoRef.key;
      commit('setNewVideoId', newVideoId);
      newVideoRef.set(video);
      // save event
      var eventId = video.event;
      eventsRef.child(eventId).child('videos').update(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, newVideoId, true));
    }
  }
});

/***/ }),

/***/ "qlHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r6jk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sKcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{attrs:{"md-active":_vm.isNewVideoDialogOpen,"md-close-on-esc":false,"md-click-outside-to-close":false},on:{"update:mdActive":function($event){_vm.isNewVideoDialogOpen=$event},"md-closed":_vm.clearForm}},[_c('md-dialog-title',[_vm._v("Submit video")]),_c('message',{attrs:{"message":"Only Twitter videos are currently supported.","icon":"warning"}}),_c('md-dialog-content',[_c('md-field',{class:_vm.getValidationClass('url')},[_c('label',{attrs:{"for":"url"}},[_vm._v("Tweet URL")]),_c('md-input',{attrs:{"name":"url","id":"url"},model:{value:(_vm.form.url),callback:function ($$v) {_vm.$set(_vm.form, "url", $$v)},expression:"form.url"}}),(!_vm.$v.form.url.required)?_c('span',{staticClass:"md-error"},[_vm._v("A video must have a tweet URL.")]):(!_vm.$v.form.url.url)?_c('span',{staticClass:"md-error"},[_vm._v("Invalid URL.")]):(!_vm.$v.form.url.tweetUrl)?_c('span',{staticClass:"md-error"},[_vm._v("URL does not link to a tweet.")]):(!_vm.$v.tweet.required && !_vm.tweetLoading)?_c('span',{staticClass:"md-error"},[_vm._v("Tweet does not contain a video.")]):_vm._e()],1),(_vm.tweet || _vm.tweetLoading)?_c('tweet-preview',{attrs:{"tweet":_vm.tweet,"loading":_vm.tweetLoading}}):_vm._e(),_c('md-field',{class:_vm.getValidationClass('event')},[_c('label',{attrs:{"for":"event"}},[_vm._v("Event")]),_c('md-select',{attrs:{"name":"event","id":"event","md-dense":"md-dense"},model:{value:(_vm.form.event),callback:function ($$v) {_vm.$set(_vm.form, "event", $$v)},expression:"form.event"}},_vm._l((_vm.eventIdsByName),function(id,name){return _c('md-option',{key:id,attrs:{"value":id}},[_vm._v(_vm._s(name))])})),(!_vm.$v.form.event.required)?_c('span',{staticClass:"md-error"},[_vm._v("A video must be assigned to an event.")]):_vm._e()],1)],1),_c('md-dialog-actions',[_c('md-button',{on:{"click":function($event){_vm.isNewVideoDialogOpen = false}}},[_vm._v("Cancel")]),_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.tweetLoading},on:{"click":_vm.submitForm}},[_vm._v("Submit")])],1)],1),_c('md-snackbar',{attrs:{"md-active":_vm.showSnackbar,"md-duration":5000},on:{"update:mdActive":function($event){_vm.showSnackbar=$event}}},[_c('span',[_vm._v("Video has been successfully submitted.")]),(_vm.newVideoId)?_c('router-link',{attrs:{"to":_vm.getLinkToVideo(_vm.newVideoId)}},[_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.showSnackbar = false}}},[_vm._v("Go to video")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "texN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TweetPreview_vue__ = __webpack_require__("6eDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_546767bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TweetPreview_vue__ = __webpack_require__("iQwS");
function injectStyle (ssrContext) {
  __webpack_require__("qlHs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-546767bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TweetPreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_546767bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TweetPreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ttC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyCard_vue__ = __webpack_require__("gh+l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d8aa80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyCard_vue__ = __webpack_require__("Ve70");
function injectStyle (ssrContext) {
  __webpack_require__("VpG+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15d8aa80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15d8aa80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uUN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VideoList__ = __webpack_require__("kBqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EventList__ = __webpack_require__("IVbU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AgencyList__ = __webpack_require__("e5vl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddSpeedDial__ = __webpack_require__("xrI/");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Browse',

  components: {
    VideoList: __WEBPACK_IMPORTED_MODULE_2__components_VideoList__["a" /* default */],
    EventList: __WEBPACK_IMPORTED_MODULE_3__components_EventList__["a" /* default */],
    AgencyList: __WEBPACK_IMPORTED_MODULE_4__components_AgencyList__["a" /* default */],
    AddSpeedDial: __WEBPACK_IMPORTED_MODULE_5__components_AddSpeedDial__["a" /* default */]
  },

  created: function created() {
    this.loadVideos();
    this.loadEvents();
    this.loadAgencies();
    this.activeTab = this.$route.name.toLowerCase();
  },
  data: function data() {
    return {
      activeTab: 'videos'
    };
  },


  watch: {
    $route: function $route(newVal, oldVal) {
      if (newVal.name !== oldVal.name) {
        this.activeTab = this.$route.name.toLowerCase();
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    videos: function videos(state) {
      return state.video.videos;
    },
    events: function events(state) {
      return state.event.events;
    },
    agencies: function agencies(state) {
      return state.agency.agencies;
    }
  })),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    loadVideos: 'video/loadVideos',
    loadEvents: 'event/loadEvents',
    loadAgencies: 'agency/loadAgencies'
  }), {
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab;
    }
  })
});

/***/ }),

/***/ "ucc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__values_tagValues__ = __webpack_require__("vJBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TagForm__ = __webpack_require__("BAph");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_image_lightbox__ = __webpack_require__("wOxb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_image_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_image_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tag-list',

  components: {
    TagForm: __WEBPACK_IMPORTED_MODULE_4__components_TagForm__["a" /* default */],
    Lightbox: __WEBPACK_IMPORTED_MODULE_7_vue_image_lightbox___default.a
  },

  props: ['tags'],

  data: function data() {
    return {
      visibleTags: this.tags,
      filter: Object(__WEBPACK_IMPORTED_MODULE_3__values_tagValues__["a" /* tagForm */])({}),
      sortBy: '#',
      sortOrder: 'asc',
      isFilterDialogOpen: false,
      isTagPlaybackAlertOpen: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    currentStageName: 'tag/currentStageName'
  }), {
    doTagsExist: function doTagsExist() {
      return this.tags && this.tags.length > 0;
    },
    filteredTags: function filteredTags() {
      var _this = this;

      // apply filter
      var filtered = this.tags && this.filter && this.tags.filter(function (tag) {
        if (_this.filter.type) {
          var doesTagMatchType = tag.details.type === _this.filter.type;
          if (doesTagMatchType) {
            // tag must match selected type
            var filter = doesTagMatchType;
            // tag sub-type values must match each selected (non-null) filter value
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_this.filter[_this.filter.type]).forEach(function (_ref) {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                  subType = _ref2[0],
                  value = _ref2[1];

              if (value) filter = filter && tag.details[subType] === value;
            });
            return filter;
          } else {
            return false; // tag doesn't match selected type
          }
        } else {
            return true; // no type, therefore no filter
          }
      });
      // apply sort
      var sorted = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["sortBy"])(filtered, function (tag) {
        if (_this.sortBy === 'number') return tag.number;
        if (_this.sortBy === 'start') return tag.range.start;
        if (_this.sortBy === 'end') return tag.range.end;
        return tag.details[_this.sortBy];
      });
      // ascending or descending order
      return this.sortOrder === 'desc' ? sorted.reverse() : sorted;
    },
    filteredTagImages: function filteredTagImages() {
      return this.filteredTags && this.filteredTags.map(function (tag) {
        return {
          src: tag.crop.images.highlighted,
          thumb: tag.crop.images.highlighted,
          caption: 'Tag #' + tag.number
        };
      });
    },
    totalCount: function totalCount() {
      return this.tags ? this.tags.length : 0;
    },
    filteredCount: function filteredCount() {
      return this.filteredTags ? this.filteredTags.length : 0;
    },
    tagCountText: function tagCountText() {
      return 'Showing ' + this.filteredCount + ' of ' + this.totalCount + ' ' + (this.totalCount === 1 ? 'tag' : 'tags');
    },
    tagListHelpText: function tagListHelpText() {
      return this.filter.type ? 'List is filtered. Clear filter to show all tags.' : 'Filter by type for more detailed information.';
    },
    areTagsPlayable: function areTagsPlayable() {
      return this.currentStageName === 'play';
    }
  }),

  watch: {
    filteredTags: function filteredTags(_filteredTags) {
      this.visibleTags = _filteredTags;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6__utilities__["d" /* mapGettersWithParams */])({
    getLinkToVideo: 'video/getLinkToVideo'
  }), {
    clearForm: function clearForm() {
      this.filter.type = null;
      this.filter.people.amount = null;
      this.filter.people.state = null;
      this.filter.people.freedom = null;
      this.filter.water.form = null;
      this.filter.vehicle.state = null;
      this.filter.area.form = null;
      this.filter.area.shelter = null;
      this.filter.area.service = null;
      this.filter.damage.form = null;
      this.filter.description = null;
    },
    capitalise: function capitalise(string) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__utilities__["a" /* capitalise */])(string);
    },
    showImage: function showImage(tagNumber) {
      var index = Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["findIndex"])(this.filteredTags, function (tag) {
        return tag.number === tagNumber;
      });
      this.$refs.lightbox.showImage(index);
    },
    formatDuration: function formatDuration(totalSeconds) {
      var leadingZero = function leadingZero(value) {
        return value < 10 ? '0' + value : value;
      };
      var minutes = leadingZero(Math.round(totalSeconds / 60));
      var seconds = leadingZero(Math.round(totalSeconds % 60));
      return minutes + ':' + seconds;
    }
  })
});

/***/ }),

/***/ "uoDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EventHeader__ = __webpack_require__("6lOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_VideoList__ = __webpack_require__("kBqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TagList__ = __webpack_require__("JnBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AddSpeedDial__ = __webpack_require__("xrI/");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Event',

  created: function created() {
    this.loadEvents();
    this.loadAgencies();
    this.loadVideos();
    this.loadTags();
  },


  components: {
    EventHeader: __WEBPACK_IMPORTED_MODULE_4__components_EventHeader__["a" /* default */],
    VideoList: __WEBPACK_IMPORTED_MODULE_5__components_VideoList__["a" /* default */],
    TagList: __WEBPACK_IMPORTED_MODULE_6__components_TagList__["a" /* default */],
    AddSpeedDial: __WEBPACK_IMPORTED_MODULE_7__components_AddSpeedDial__["a" /* default */]
  },

  data: function data() {
    return {
      activeTab: 'videos'
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapState */])({
    areEventsLoaded: function areEventsLoaded(state) {
      return state.event.areEventsLoaded;
    },
    areAgenciesLoaded: function areAgenciesLoaded(state) {
      return state.agency.areAgenciesLoaded;
    },
    areVideosLoaded: function areVideosLoaded(state) {
      return state.video.areVideosLoaded;
    },
    areTagsLoaded: function areTagsLoaded(state) {
      return state.tag.areTagsLoaded;
    }
  }), {
    event: function event() {
      if (this.areEventsLoaded && this.$route.params.eventId) {
        return this.getEventById(this.$route.params.eventId);
      }
    },
    agencies: function agencies() {
      if (this.areAgenciesLoaded && this.event && this.event.agencies) {
        return this.getAgenciesByIds(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.event.agencies));
      }
    },
    videos: function videos() {
      if (this.areVideosLoaded && this.event && this.event.videos) {
        return this.getVideosByIds(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.event.videos));
      }
    },
    tags: function tags() {
      if (this.areTagsLoaded && this.event && this.event.videos) {
        return this.getTagsByVideoIds(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.event.videos));
      }
    },
    image: function image() {
      if (this.event) {
        return this.getImage(this.event);
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    loadEvents: 'event/loadEvents',
    loadAgencies: 'agency/loadAgencies',
    loadVideos: 'video/loadVideos',
    loadTags: 'tag/loadTags'
  }), Object(__WEBPACK_IMPORTED_MODULE_3__utilities__["d" /* mapGettersWithParams */])({
    getEventById: 'event/getEventById',
    getAgenciesByIds: 'agency/getAgenciesByIds',
    getVideosByIds: 'video/getVideosByIds',
    getTagsByVideoIds: 'tag/getTagsByVideoIds',
    getImage: 'event/getImage'
  }), {
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab;
    }
  })
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vJBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tagTypeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tagTypeValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tagForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tagValidations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);



var tagTypeNames = ['people', 'water', 'vehicle', 'area', 'damage', 'other'];

var tagTypeValues = {
  people: {
    amount: ['one person', 'more than one person'],
    state: ['all healthy', 'some injured', 'some dead', 'mixed'],
    freedom: ['walking', 'unable to walk', 'trapped']
  },
  water: {
    form: ['flood', 'natural environment', 'distributed safely']
  },
  vehicle: {
    state: ['working', 'broken', 'unsure']
  },
  area: {
    form: ['provided by relief effort', 'makeshift'],
    shelter: ['sheltered', 'not sheltered'],
    service: ['food', 'water', 'medical aid', 'human remains management', 'other supplies']
  },
  damage: {
    form: ['fire', 'collapsed structure', 'unstable structure', 'road blockage', 'compromised bridge', 'damaged power or communication line', 'landslide']
  }
};

var tagForm = function tagForm(_ref) {
  var includeDescription = _ref.includeDescription;

  var tagForm = {};
  // copy tagTypeValues to tagForm, replacing all arrays with null
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tagTypeValues).forEach(function (type) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tagTypeValues[type]).forEach(function (subType) {
      if (!tagForm[type]) tagForm[type] = {};
      tagForm[type][subType] = null;
    });
  });
  // non sub-type fields
  tagForm.type = null;
  if (includeDescription) tagForm.description = null;
  return tagForm;
};

var tagValidations = function tagValidations(_ref2) {
  var selectedType = _ref2.selectedType;

  // always applied no matter the selected type
  var validations = {
    form: {
      type: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] },
      description: { maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(800) }
    }
  };
  if (selectedType === 'other') {
    // if selected type is other, then description is required
    validations.form.description.required = __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"];
  } else if (selectedType) {
    // if selected type has sub-types, then all sub-types are required
    var subTypeValidations = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tagTypeValues[selectedType]).forEach(function (subType) {
      subTypeValidations[subType] = { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"] };
    });
    validations.form[selectedType] = subTypeValidations;
  }
  return validations;
};

/***/ }),

/***/ "vaj8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'message',

  props: {
    message: String,
    icon: String
  }
});

/***/ }),

/***/ "wZO3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xC7r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__values_tagValues__ = __webpack_require__("vJBD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__("yp89");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tag-form',

  props: ['form', 'showDescription', 'clearable', '$v'],

  data: function data() {
    return {
      localForm: this.form,
      types: __WEBPACK_IMPORTED_MODULE_0__values_tagValues__["b" /* tagTypeNames */],
      values: __WEBPACK_IMPORTED_MODULE_0__values_tagValues__["c" /* tagTypeValues */]
    };
  },
  created: function created() {
    this.$emit('update:form', this.localForm);
  },


  methods: {
    getValidationClass: function getValidationClass(fieldName, subFieldName) {
      if (this.$v) {
        var field = subFieldName ? this.$v.form[fieldName][subFieldName] : this.$v.form[fieldName];
        if (field) {
          return {
            'md-invalid': field.$error
          };
        }
      }
    },
    capitalise: function capitalise(string) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utilities__["a" /* capitalise */])(string);
    }
  }
});

/***/ }),

/***/ "xGCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NewTagDialog__ = __webpack_require__("Ah09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VideoTagger__ = __webpack_require__("hC2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TagList__ = __webpack_require__("JnBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VideoInfo__ = __webpack_require__("cfFy");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Video',

  components: {
    NewTagDialog: __WEBPACK_IMPORTED_MODULE_3__components_NewTagDialog__["a" /* default */],
    VideoTagger: __WEBPACK_IMPORTED_MODULE_4__components_VideoTagger__["a" /* default */],
    TagList: __WEBPACK_IMPORTED_MODULE_5__components_TagList__["a" /* default */],
    VideoInfo: __WEBPACK_IMPORTED_MODULE_6__components_VideoInfo__["a" /* default */]
  },

  created: function created() {
    this.loadVideos();
    this.loadTags();
    this.loadEvents();
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    areVideosLoaded: function areVideosLoaded(state) {
      return state.video.areVideosLoaded;
    },
    areTagsLoaded: function areTagsLoaded(state) {
      return state.tag.areTagsLoaded;
    },
    areEventsLoaded: function areEventsLoaded(state) {
      return state.event.areEventsLoaded;
    }
  }), {
    video: function video() {
      var videoId = this.$route.params.videoId;

      if (this.areVideosLoaded && videoId) {
        return this.getVideoById(videoId);
      }
    },
    tags: function tags() {
      var videoId = this.$route.params.videoId;

      if (this.areTagsLoaded && videoId) {
        return this.getTagsByVideoId(videoId);
      }
    },
    event: function event() {
      if (this.areEventsLoaded && this.video && this.video.event) {
        return this.getEventById(this.video.event);
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    loadVideos: 'video/loadVideos',
    loadTags: 'tag/loadTags',
    loadEvents: 'event/loadEvents'
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getVideoById: 'video/getVideoById',
    getTagsByVideoId: 'tag/getTagsByVideoId',
    getEventById: 'event/getEventById'
  }))
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Toolbar__ = __webpack_require__("djO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Drawer__ = __webpack_require__("SczH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewAgencyDialog__ = __webpack_require__("X4+w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NewEventDialog__ = __webpack_require__("p+gE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewVideoDialog__ = __webpack_require__("jrjd");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    Toolbar: __WEBPACK_IMPORTED_MODULE_2__components_Toolbar__["a" /* default */],
    Drawer: __WEBPACK_IMPORTED_MODULE_3__components_Drawer__["a" /* default */],
    NewAgencyDialog: __WEBPACK_IMPORTED_MODULE_4__components_NewAgencyDialog__["a" /* default */],
    NewEventDialog: __WEBPACK_IMPORTED_MODULE_5__components_NewEventDialog__["a" /* default */],
    NewVideoDialog: __WEBPACK_IMPORTED_MODULE_6__components_NewVideoDialog__["a" /* default */]
  },

  data: function data() {
    return {
      email: '',
      password: '',
      passwordAgain: ''
    };
  },
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('auth/getUser');
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    isUserLoaded: function isUserLoaded(state) {
      return state.auth.isUserLoaded;
    }
  }))
});

/***/ }),

/***/ "xXYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__("yp89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-event-dialog',

  created: function created() {
    this.loadAgencies();
  },
  data: function data() {
    return {
      form: {
        name: null,
        description: null,
        agencies: []
      },
      showSnackbar: false
    };
  },


  validations: {
    form: {
      name: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(3)
      },
      description: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
        maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(800)
      },
      agencies: {
        required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])({
    newEventId: function newEventId(state) {
      return state.event.newEventId;
    }
  }), Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["c" /* mapBoolean */])({
    namespace: 'ui',
    key: 'isNewEventDialogOpen',
    setTrue: 'openNewEventDialog',
    setFalse: 'closeNewEventDialog'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    agencyNames: 'agency/agencyNames',
    agencyIdsByName: 'agency/agencyIdsByName'
  })),

  watch: {
    isNewEventDialogOpen: function isNewEventDialogOpen(newVal) {
      // when new event dialog opens...
      if (newVal) {
        // if on agency page...
        if (this.$route.params.agencyId) {
          // pre-fill form with agency
          var agencyId = this.$route.params.agencyId;

          this.form.agencies = [agencyId];
        }
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2__utilities__["d" /* mapGettersWithParams */])({
    getLinkToEvent: 'event/getLinkToEvent'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    saveNewEvent: 'event/saveNewEvent',
    loadAgencies: 'agency/loadAgencies'
  }), {
    getValidationClass: function getValidationClass(fieldName) {
      var field = this.$v.form[fieldName];
      if (field) {
        return {
          'md-invalid': field.$error
        };
      }
    },
    clearForm: function clearForm() {
      this.$v.$reset();
      this.form.name = null;
      this.form.description = null;
      this.form.agencies = [];
    },
    submitForm: function submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // transform list of agency names into agencyId index
        var agencies = {};
        this.form.agencies.forEach(function (agencyId) {
          agencies[agencyId] = true;
        });
        // save event
        this.saveNewEvent({
          event: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.form, {
            agencies: agencies
          })
        });
        // close form
        this.isNewEventDialogOpen = false;
        this.showSnackbar = true;
      }
    }
  })
});

/***/ }),

/***/ "xrI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSpeedDial_vue__ = __webpack_require__("eQ72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfa11d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AddSpeedDial_vue__ = __webpack_require__("P8kE");
function injectStyle (ssrContext) {
  __webpack_require__("Y4Wj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfa11d7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSpeedDial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfa11d7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_AddSpeedDial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xzpI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__ = __webpack_require__("xGCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1047e23c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__ = __webpack_require__("amq5");
function injectStyle (ssrContext) {
  __webpack_require__("1OUD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1047e23c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1047e23c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yJ2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__("vaj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206ddb68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__ = __webpack_require__("ligT");
function injectStyle (ssrContext) {
  __webpack_require__("b8Uq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-206ddb68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206ddb68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ydlG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yjWt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yp89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mapBoolean;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapGettersWithParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTweetUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_parse__ = __webpack_require__("dyOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_url_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_url_parse__);






function mapBoolean(_ref) {
  var namespace = _ref.namespace,
      key = _ref.key,
      setTrue = _ref.setTrue,
      setFalse = _ref.setFalse;

  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, {
    get: function get() {
      return this.$store.state[namespace][key];
    },
    set: function set(value) {
      if (value) this.$store.commit(namespace + '/' + setTrue);else this.$store.commit(namespace + '/' + setFalse);
    }
  });
}

function mapGettersWithParams(paramGetters) {
  var returnObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, paramGetters);
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(returnObject).forEach(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        key = _ref4[0],
        val = _ref4[1];

    returnObject[key] = function () {
      var _$store$getters;

      return (_$store$getters = this.$store.getters)[val].apply(_$store$getters, arguments);
    };
  });
  return returnObject;
}

// export function isYouTubeUrl (url) {
//   const {hostname} = urlParse(url)
//   return [
//     'www.youtube.com',
//     'youtu.be',
//   ].includes(hostname)
// }

// export function extractYouTubeVideoId (url) {
//   const {hostname, pathname, query} = urlParse(url, true)
//   let videoId
//   if (hostname === 'www.youtube.com' && pathname === '/watch') {
//     videoId = query.v
//   } else if (hostname === 'youtu.be') {
//     videoId = pathname.substring(1)
//   }
//   return videoId && (videoId.length === 11 ? videoId : undefined)
// }

function isTweetUrl(url) {
  var _urlParse = __WEBPACK_IMPORTED_MODULE_4_url_parse___default()(url),
      hostname = _urlParse.hostname,
      pathname = _urlParse.pathname;

  var tweetPathnameRegex = /^\/[^/]+\/status\/[0-9]+$/;
  return hostname === 'twitter.com' && tweetPathnameRegex.test(pathname);
}

function capitalise(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ "z6Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog-content',[_c('div',{staticClass:"clearable-field"},[_c('md-field',{class:_vm.getValidationClass('type')},[_c('label',{attrs:{"for":"type"}},[_vm._v("Type")]),_c('md-select',{attrs:{"placeholder":_vm.clearable ? 'Any type' : '',"name":"type","md-dense":"md-dense"},model:{value:(_vm.localForm.type),callback:function ($$v) {_vm.$set(_vm.localForm, "type", $$v)},expression:"localForm.type"}},_vm._l((_vm.types),function(type){return _c('md-option',{key:type,attrs:{"value":type}},[_vm._v(_vm._s(type))])})),(_vm.$v && !_vm.$v.form.type.required)?_c('span',{staticClass:"md-error"},[_vm._v("Required.")]):_vm._e()],1),(_vm.clearable && _vm.localForm.type)?_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.localForm.type = null}}},[_c('md-icon',[_vm._v("close")])],1):_vm._e()],1),_vm._l((_vm.values),function(subTypes,type){return (_vm.form.type === type)?_c('div',{key:type},_vm._l((subTypes),function(options,subType){return _c('div',{staticClass:"clearable-field"},[_c('md-field',{key:(type + "-" + subType),class:_vm.getValidationClass(type, subType)},[_c('label',{attrs:{"for":(type + "-" + subType)}},[_vm._v(_vm._s(_vm.capitalise(subType)))]),_c('md-select',{attrs:{"placeholder":_vm.clearable ? ("Any " + subType) : '',"name":(type + "-" + subType),"md-dense":"md-dense"},model:{value:(_vm.localForm[type][subType]),callback:function ($$v) {_vm.$set(_vm.localForm[type], subType, $$v)},expression:"localForm[type][subType]"}},_vm._l((options),function(option){return _c('md-option',{key:option,attrs:{"value":option}},[_vm._v(_vm._s(option))])})),(_vm.$v && !_vm.$v.form[type][subType].required)?_c('span',{staticClass:"md-error"},[_vm._v("Required.")]):_vm._e()],1),(_vm.clearable && _vm.localForm[type][subType])?_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.localForm[type][subType] = null}}},[_c('md-icon',[_vm._v("close")])],1):_vm._e()],1)})):_vm._e()}),(_vm.showDescription)?_c('md-field',{class:_vm.getValidationClass('description')},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description")]),_c('md-textarea',{attrs:{"name":"description"},model:{value:(_vm.localForm.description),callback:function ($$v) {_vm.$set(_vm.localForm, "description", $$v)},expression:"localForm.description"}}),(_vm.$v && _vm.$v.form.description && !_vm.$v.form.description.required)?_c('span',{staticClass:"md-error"},[_vm._v("Required.")]):_vm._e()],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z6Yr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__ = __webpack_require__("a4Ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4d664f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__ = __webpack_require__("fn2C");
function injectStyle (ssrContext) {
  __webpack_require__("eI/d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b4d664f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4d664f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_EventCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTpQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e58415668904457bb0ac.js